export default {
  translation: {
    // Flexar: app-wide route error boundary (components/fallback-component)
    error_boundary: {
      title: 'Что-то пошло не так',
      description: 'Не удалось загрузить страницу.',
      details: 'Детали ошибки',
      reload: 'Перезагрузить',
      retry: 'Повторить',
      updating: 'Обновление приложения…',
    },
    // Flexar: admin analytics page (pages/admin/analytics.tsx)
    // Flexar: отчёт «Расходы» (PILOTFLEXARBR-44)
    expenses: {
      title: 'Расходы',
      subtitle:
        'Сколько стоят обращения к моделям — по данным провайдеров о расходе и ценам из справочника.',
      approx:
        'Сумма приблизительная: считается из токенов и цен провайдера; точная — в кабинете провайдера.',
      pricesByAdmin: 'Цены моделей задаёт администратор.',
      group: {
        period: 'По периодам',
        caller_account_id: 'По сотрудникам',
        model_id: 'По моделям',
        dialog_id: 'По ассистентам',
        app_id: 'По приложениям',
      },
      col: {
        period: 'Период',
        caller_account_id: 'Сотрудник',
        model_id: 'Модель',
        dialog_id: 'Ассистент',
        app_id: 'Приложение',
        requests: 'Обращения',
        promptTokens: 'Токены (вход)',
        completionTokens: 'Токены (выход)',
        cost: 'Стоимость',
        share: 'Доля',
      },
      stat: {
        cost: 'Стоимость',
        costHint: 'цена известна для {{priced}} из {{requests}} обращений',
        requests: 'Обращения',
        tokens: 'Токены',
        tokensHint: 'вход {{prompt}} · выход {{completion}}',
        perRequest: 'За обращение',
        perRequestHint: 'по обращениям с известной ценой',
      },
      chartTitle: 'Стоимость {{group}}',
      externalUsers: 'Внешние пользователи',
      noApp: 'Без токена',
      unknownModel: 'Модель не определена',
      total: 'Итого',
      noData: 'За выбранный период расходов нет',
      export: 'Экспорт Excel',
      exporting: 'Экспорт…',
      error: {
        load: 'Не удалось загрузить расходы',
        retry: 'Повторить',
        export: 'Не удалось выгрузить отчёт',
      },
      prices: {
        title: 'Цены моделей',
        subtitle:
          'Рубли за 1 млн токенов. Цены cloud.ru и VseLLM подгружаются автоматически раз в сутки; заданные вручную не перезаписываются.',
        sync: 'Обновить у провайдера',
        syncing: 'Обновляем…',
        synced: 'Обновлено моделей: {{updated}}',
        syncedWithFailures: 'Обновлено: {{updated}}, без цены: {{failed}}',
        syncFailed: 'Не удалось обновить цены',
        col: {
          factory: 'Провайдер',
          model: 'Модель',
          prompt: 'Вход',
          completion: 'Выход',
          cached: 'Кеш',
          source: 'Источник',
          synced: 'Обновлено',
        },
        source: {
          provider: 'провайдер',
          manual: 'вручную',
          none: 'нет цены',
        },
        tiers: 'ступени контекста: {{count}}',
        edit: 'Изменить',
        reset: 'Вернуть цену провайдера',
        editTitle: 'Цена модели',
        editHint: 'Рубли за 1 млн токенов',
        promptLabel: 'Входные токены',
        completionLabel: 'Выходные токены',
        cachedLabel: 'Кешированные входные (необязательно)',
        save: 'Сохранить',
        cancel: 'Отмена',
        saved: 'Цена сохранена',
        saveFailed: 'Не удалось сохранить цену',
        invalid: 'Укажите неотрицательные числа',
        resetDone: 'Цена провайдера восстановлена',
        empty: 'Моделей с тарифицируемым провайдером нет',
      },
    },
    analytics: {
      col: {
        period: 'Период',
        dialog_id: 'Ассистент',
        source: 'Канал',
        app_id: 'Приложение',
        caller_account_id: 'Пользователь',
        tenant_id: 'Тенант',
        model_id: 'Модель', // Flexar: PILOTFLEXARBR-44
      },
      met: {
        requests: 'Обращения',
        users: 'Пользователи',
        anon: 'Анонимные',
        conversations: 'Диалоги',
        answered: 'Отвечено',
      },
      groupLabel: {
        period: 'периодам',
        dialog_id: 'ассистентам',
        source: 'каналам',
        app_id: 'приложениям',
        caller_account_id: 'пользователям',
        tenant_id: 'тенантам',
        model_id: 'моделям', // Flexar: PILOTFLEXARBR-44
      },
      source: {
        web_ui: 'Веб-интерфейс',
        web_embedded: 'Веб (встроенный чат)',
        widget: 'Виджет',
        agent: 'Агент',
        agent_openai: 'Агент (OpenAI)',
      },
      mode: { exclude: 'Кроме', include: 'Только' },
      preset: {
        d7: '7 дней',
        d30: '30 дней',
        d90: '90 дней',
        month: 'Этот месяц',
      },
      field: {
        groupBy: 'Группировка',
        granularity: 'Гранулярность',
        tenants: 'Тенанты',
      },
      assistantAll: 'Все',
      granularity: { day: 'День', week: 'Неделя', month: 'Месяц' },
      search: {
        users: 'Поиск пользователей…',
        tenants: 'Поиск тенантов…',
        applications: 'Поиск приложений…',
        channels: 'Поиск каналов…',
      },
      empty: {
        nothingFound: 'Ничего не найдено',
        noApplications: 'Нет приложений (API-токенов)',
        noChannelData: 'Нет данных по каналам',
      },
      button: {
        copyLink: 'Скопировать ссылку',
        exportExcel: 'Экспорт Excel',
        exporting: 'Экспорт…',
      },
      stat: {
        requests: 'Обращений',
        users: 'Пользователей',
        answered: 'Отвечено',
        anonHint: '+{{count}} анонимных',
        anonTooltip:
          'Анонимные сессии виджета (без идентификации посетителя) — считаются по сессиям, не входят в «Пользователей».',
      },
      total: 'Итого',
      hideZeros: 'Скрывать нули',
      columns: 'Колонки',
      noDataForPeriod: 'Нет данных за выбранный период',
      summaryPrefix:
        'Учитываются обращения, удовлетворяющие всем условиям сразу:',
      summary: {
        assistant: 'ассистент',
        all: 'все',
        only: 'только',
        except: 'кроме',
        tenants: 'тенанты',
        users: 'пользователи',
        applications: 'приложения',
        channels: 'каналы',
      },
      chartTitle: 'Обращения по {{groups}}',
      cell: {
        externalNoAccount: 'Внешний / без аккаунта',
        noModel: 'Модель не определена', // Flexar: PILOTFLEXARBR-44
      },
      error: {
        load: 'Не удалось загрузить данные. Проверьте подключение и попробуйте снова.',
        retry: 'Повторить',
      },
      toast: {
        exportGenerateFailed: 'Не удалось сформировать отчёт',
        exportFailed: 'Не удалось выгрузить отчёт',
        linkCopied: 'Ссылка на отчёт скопирована',
        copyFromAddressBar: 'Скопируйте ссылку из адресной строки',
      },
    },
    common: {
      delete: 'Удалить',
      deleteModalTitle: 'Вы уверены, что хотите удалить этот элемент?',
      ok: 'Да',
      cancel: 'Отмена',
      total: 'Всего',
      rename: 'Переименовать',
      name: 'Название',
      save: 'Сохранить',
      namePlaceholder: 'Введите название',
      next: 'Далее',
      create: 'Создать',
      edit: 'Редактировать',
      editShort: 'Ред.',
      upload: 'Загрузить',
      english: 'Английский',
      portugueseBr: 'Португальский (Бразилия)',
      chinese: 'Упрощенный китайский',
      traditionalChinese: 'Традиционный китайский',
      language: 'Язык',
      languageMessage: 'Пожалуйста, укажите язык!',
      languagePlaceholder: 'Выберите язык',
      copy: 'Копировать',
      copied: 'Скопировано',
      comingSoon: 'Скоро будет',
      download: 'Скачать',
      close: 'Закрыть',
      preview: 'Просмотр',
      move: 'Переместить',
      warn: 'Предупреждение',
      action: 'Действие',
      s: 'С',
      pleaseSelect: 'Выберите',
      pleaseInput: 'Введите',
      submit: 'Применить',
      add: 'Добавить',
      clear: 'Очистить',
      no: 'Нет',
      noData: 'Нет данных',
      noDataFound: 'Данные не найдены.',
      noResults: 'Нет результатов.',
      highLoadWarning:
        'Система сейчас испытывает повышенный спрос. Ответы могут занимать больше времени.',
      yes: 'Да',
      remove: 'Удалить',
      search: 'Поиск',
      selectAll: 'Выбрать все',
      selectPlaceholder: 'выберите значение',
      share: 'Поделиться',
      owner: 'Владелец',
      embedIntoSite: 'Встроить на веб-страницу',
      previousPage: 'Назад',
      nextPage: 'Вперед',
      promptPlaceholder:
        'Введите текст или используйте / для быстрой вставки переменных.',
      mcp: {
        namePlaceholder: 'Мой MCP сервер',
        nameRequired:
          'Должно быть 1-64 символов и содержать только буквы, цифры, дефисы и подчеркивания.',
        urlPlaceholder: 'https://api.example.com/v1/mcp',
        tokenPlaceholder: 'например, eyJhbGciOiJIUzI1Ni...',
      },
      error: 'Ошибка',
      link: 'Подключить',
      openLink: 'Открыть ссылку',
      operationFailed: 'Операция не удалась',
      pleaseSelectKnowledgeBase:
        'Пожалуйста, выберите хотя бы одну базу знаний',
      russian: 'Русский',
      selectKnowledgeBase: 'База знаний',
      update: 'Обновить',
      seeAll: 'Все',
      back: 'Назад',
      moreActions: 'Ещё действия',
      confirm: 'Подтвердить',
      loading: 'Загрузка...',
      deleteThem: 'Вы уверены, что хотите удалить выбранные элементы?',
      selected: 'Выбрано',
      pageNotFound: 'Страница не найдена. Проверьте правильность адреса.',
      goHome: 'На главную',
    },
    login: {
      loginTitle: 'Войдите в аккаунт',
      signUpTitle: 'Создайте аккаунт',
      start: 'Давайте начнем',
      login: 'Войти',
      signUp: 'Регистрация',
      loginDescription: 'Рады снова видеть вас!',
      registerDescription: 'Рады приветствовать вас на борту!',
      signInWith: 'Войти через {{provider}}',
      emailLabel: 'Email',
      emailPlaceholder: 'Введите email',
      passwordLabel: 'Пароль',
      passwordPlaceholder: 'Введите пароль',
      rememberMe: 'Запомнить меня',
      signInTip: 'Нет аккаунта?',
      signUpTip: 'Уже есть аккаунт?',
      nicknameLabel: 'Никнейм',
      nicknamePlaceholder: 'Введите никнейм',
      register: 'Создать аккаунт',
      continue: 'Продолжить',
      title: 'Начните создавать умных помощников.',
      description:
        'Зарегистрируйтесь бесплатно, чтобы изучить передовые RAG-технологии. Создавайте базы знаний и ИИ для развития вашего бизнеса.',
      review: 'на основе 500+ отзывов',
      alreadyRegistered: 'Email уже зарегистрирован',
      codeLabel: 'Email Код',
      codePlaceholder: 'Введите код',
      confirmPasswordLabel: 'Подтвердите',
      confirmPasswordPlaceholder: 'Подтвердите ваш пароль',
      invalidCode: 'Неверный код',
      oauthErrors: {
        invalid_state: 'Сессия авторизации устарела. Попробуйте войти заново.',
        missing_code: 'Провайдер не вернул код авторизации.',
        token_failed: 'Не удалось обменять код на токен.',
        email_missing: 'Провайдер не вернул email пользователя.',
        email_domain_not_allowed: 'Не разрешён вход для вашего email',
        user_inactive: 'Учётная запись деактивирована.',
        registration_failed:
          'Не удалось создать учётную запись. Напишите администратору.',
        oauth_failed: 'Не удалось войти через провайдера. Попробуйте ещё раз.',
        unknown: 'Не удалось войти через провайдера ({{code}}).',
      },
      loginLabel: 'Логин',
      loginPlaceholder: 'Введите email или имя пользователя',
      passwordMismatch: 'Введенные пароли не совпадают!',
      registrationFailed: 'Регистрация не удалась',
      resend: 'Повтор через {{count}}с',
      sendCode: 'Отправить код',
      sendCodeSuccess: 'Код подтверждения успешно отправлен!',
      sending: 'Отправка...',
      usernameLabel: 'Имя пользователя',
      usernamePlaceholder: 'Введите имя пользователя',
    },
    header: {
      menu: 'Меню',
      Root: 'Витрина',
      knowledgeBase: 'Базы знаний',
      chat: 'Чаты',
      register: 'Регистрация',
      signin: 'Вход',
      home: 'Витрина',
      setting: 'Настройки пользователя',
      logout: 'Выйти',
      fileManager: 'Управление файлами',
      flow: 'Агенты',
      search: 'Поиск',
      welcome: 'Добро пожаловать в',
      dataset: 'Базы знаний',
      memories: 'Память',
    },
    knowledgeList: {
      welcome: 'С возвращением',
      description: 'Какие базы знаний вы будете использовать сегодня?',
      createKnowledgeBase: 'Создать базу знаний',
      name: 'Название',
      namePlaceholder: 'Введите название!',
      doc: 'Документы',
      searchKnowledgePlaceholder: 'Поиск',
      noMoreData: 'Это всё. Больше ничего нет.',
      parserRequired: 'Выберите метод парсинга.',
      dataFlowRequired: 'Выберите конвейер загрузки.',
    },
    knowledgeDetails: {
      close: 'Закрыть',
      completed: 'Завершено',
      dataPipeline: 'Конвейер загрузки',
      datasetLog: 'Лог базы знаний',
      datasetLogs: 'База знаний',
      details: 'Детали',
      duration: 'Длительность',
      failed: 'Ошибка',
      fileLogs: 'Лог обработки',
      fileName: 'Имя файла',
      fileSize: 'Размер файла',
      files: 'файлов',
      generate: 'Сгенерировать',
      generateKnowledgeGraph: 'Сгенерировать граф знаний',
      generateRaptor: 'Сгенерировать RAPTOR',
      generatedOn: 'Сгенерировано ',
      localUpload: 'Локальная загрузка',
      notGenerated: 'Не сгенерировано',
      operations: 'Операции',
      overview: 'Логи',
      processingType: 'Тип обработки',
      raptor: 'RAPTOR',
      source: 'Источник',
      startDate: 'Дата начала',
      subbarFiles: 'Файлы',
      success: 'Успех',
      task: 'Задача',
      taskId: 'ID задачи',
      theDocumentBeingParsedCannotBeDeleted:
        'Документ, который сейчас парсится, нельзя удалить',
      uploadedBy: 'Загрузил',
      dataset: 'База знаний',
      testing: 'Тестирование поиска',
      documents_one: '{{count}} документ',
      documents_few: '{{count}} документа',
      documents_many: '{{count}} документов',
      documents_other: '{{count}} документов',
      configuration: 'Конфигурация',
      knowledgeGraph: 'Граф знаний',
      name: 'Название',
      namePlaceholder: 'Введите название!',
      doc: 'Документы',
      datasetDescription:
        '😉 Пожалуйста, дождитесь завершения обработки данных перед началом чата с ИИ.',
      addFile: 'Добавить источник',
      exportXlsx: 'Экспорт в Excel',
      exportXlsxTooltip:
        'Скачать XLSX-отчёт по всем документам базы знаний — удобно для аудита: что оставить, заменить или удалить.',
      exportXlsxFailed: 'Не удалось выгрузить документы. Попробуйте ещё раз.',
      searchFiles: 'Поиск файлов',
      localFiles: 'Локальные файлы',
      emptyFiles: 'Создать пустой файл',
      webCrawl: 'Веб-сканирование',
      chunkNumber: 'Количество фрагментов',
      uploadDate: 'Дата загрузки',
      chunkMethod: 'Метод фрагментации',
      enabled: 'Включено',
      disabled: 'Отключено',
      action: 'Действие',
      parsingStatus: 'Статус обработки',
      parsingStatusTip:
        'Время обработки документа зависит от нескольких факторов. Включение таких функций, как Граф знаний, RAPTOR, Автоизвлечение вопросов или Автоизвлечение ключевых слов, значительно увеличит время обработки. Если индикатор выполнения завис, обратитесь к FAQ: https://flexar.ai/docs/dev/faq#why-does-my-document-parsing-stall-at-under-one-percent.',
      processBeginAt: 'Начато в',
      processDuration: 'Длительность',
      progressMsg: 'Прогресс',
      testingDescription:
        'Проведите тест поиска, чтобы проверить, может ли Flexar находить нужный контент для LLM. Если вы изменили настройки по умолчанию (например, вес сходства ключевых слов или порог сходства), имейте в виду, что эти изменения не сохранятся автоматически. Вы должны применить их в настройках чат-ассистента или компонента поиска.',
      similarityThreshold: 'Порог сходства',
      similarityThresholdTip:
        'Flexar использует взвешенное сходство ключевых слов в комбинации с косинусным сходством векторов или реранкингом. Этот параметр устанавливает порог сходства между запросом пользователя и фрагментами. Фрагменты с оценкой ниже порога будут исключены из результатов. По умолчанию порог установлен на 0.2.',
      vectorSimilarityWeight: 'Вес сходства ключевых слов',
      vectorSimilarityWeightTip:
        'Устанавливает вес сходства ключевых слов в общей оценке сходства. Сумма весов должна быть равна 1.0.',
      testText: 'Тестовый текст',
      testTextPlaceholder: 'Введите ваш вопрос здесь!',
      testingLabel: 'Тестирование',
      similarity: 'Комбинированное сходство',
      termSimilarity: 'Сходство терминов',
      vectorSimilarity: 'Векторное сходство',
      hits: 'Найденные результаты',
      view: 'Просмотр',
      filesSelected: 'Выбрано файлов',
      upload: 'Загрузить',
      run: 'Обработать',
      runningStatus0: 'ОЖИДАЕТ',
      runningStatus1: 'ОБРАБАТЫВАЕТ',
      runningStatus2: 'ОТМЕНЕНО',
      runningStatus3: 'УСПЕШНО',
      runningStatus4: 'ОШИБКА',
      pageRanges: 'Диапазон страниц',
      pageRangesTip:
        'Диапазон страниц для обработки; страницы вне диапазона обрабатываться не будут.',
      fromPlaceholder: 'от',
      fromMessage: 'Не указан номер начальной страницы',
      toPlaceholder: 'до',
      toMessage: 'Не указан номер конечной страницы (не включительно)',
      layoutRecognize: 'Анализатор PDF',
      layoutRecognizeTip:
        'Используйте визуальную модель для анализа макета PDF для эффективного определения заголовков, текстовых блоков, изображений и таблиц. При выборе опции "Простой" извлекается только простой текст из PDF.',
      taskPageSize: 'Размер задачи',
      taskPageSizeMessage: 'Укажите размер задачи!',
      taskPageSizeTip:
        'При распознавании макета PDF-файл разбивается на части для параллельной обработки. Этот параметр задает размер каждой части.',
      addPage: 'Добавить страницу',
      greaterThan: 'Текущее значение должно быть больше предыдущего!',
      greaterThanPrevious:
        'Текущее значение должно быть больше предыдущего "до"!',
      selectFiles: 'Выбрать файлы',
      changeSpecificCategory: 'Изменить категорию',
      uploadTitle: 'Перетащите файлы для загрузки',
      uploadDescription: 'Поддерживает одиночную или пакетную загрузку.',
      chunk: 'Фрагмент',
      bulk: 'Пакетно',
      cancel: 'Отмена',
      rerankModel: 'Модель реранкинга',
      rerankPlaceholder: 'Выберите',
      rerankTip:
        'Опционально. Если оставить пустым, Flexar будет использовать комбинацию сходства ключевых слов и векторов. Выбор модели реранкинга заменит векторное сходство на оценку реранкинга.',
      topK: 'Топ-K',
      topKTip:
        'Определяет количество текстовых фрагментов, отправляемых в модель реранкинга.',
      delimiter: 'Разделитель текста',
      delimiterTip:
        'Разделитель может состоять из одного или нескольких спецсимволов. Для нескольких символов укажите их в обратных кавычках (``).',
      html4excel: 'Excel в HTML',
      html4excelTip:
        'При включении электронные таблицы будут преобразованы в HTML-таблицы.',
      autoKeywords: 'Авто-ключевые слова',
      autoKeywordsTip:
        'Автоматически извлекает N ключевых слов для каждого фрагмента.',
      autoQuestions: 'Авто-вопросы',
      autoQuestionsTip:
        'Автоматически извлекает N вопросов для каждого фрагмента.',
      redo: 'Очистить существующие {{chunkNum}} фрагментов?',
      setMetaData: 'Установить метаданные',
      pleaseInputJson: 'Введите JSON',
      documentMetaTips:
        '<p>Метаданные в формате JSON (не индексируются). Добавляются в промпт для LLM, если фрагменты документа включены в промпт.</p>\n' +
        '<p>Примеры:</p>\n' +
        '<b>Метаданные:</b><br>\n' +
        '<code>\n' +
        '  {\n' +
        '      "Автор": "Алекс Доусон",\n' +
        '      "Дата": "2024-11-12"\n' +
        '  }\n' +
        '</code><br>\n' +
        '<b>Промпт будет:</b><br>\n' +
        '<p>Документ: название_документа</p>\n' +
        '<p>Автор: Алекс Доусон</p>\n' +
        '<p>Дата: 2024-11-12</p>\n' +
        '<p>Релевантные фрагменты:</p>\n' +
        '<ul>\n' +
        '<li>Содержание фрагмента...</li>\n' +
        '<li>Содержание фрагмента...</li>\n' +
        '</ul>\n',
      metaData: 'Метаданные',
      deleteDocumentConfirmContent:
        'Документ связан с графом знаний. После удаления связанная информация о узлах и связях будет удалена, но граф не обновится немедленно.',
      plainText: 'Простой',
      reRankModelWaring: 'Модель реранкинга требует много времени.',
      connect: 'Подключить',
      extractionModeLlm: 'Семантический через LLM',
      extractionModePlain: 'Детерминированный (простой)',
      hours: 'часов',
      telegramChannel: 'Телеграм',
      website: 'Сайт',
      websiteExcludePrefixesLabel: 'Исключить префиксы URL',
      websiteExcludePrefixesPlaceholder: 'Введите префиксы через запятую',
      websiteExcludePrefixesTooltip:
        'Пропустить сканирование URL, начинающихся с этих префиксов пути (например, /admin, /login)',
      websiteExtractionModeLabel: 'Режим извлечения',
      websiteExtractionModeRequired: 'Пожалуйста, выберите режим извлечения',
      websiteExtractionModeTooltip:
        'Способ извлечения основного контента со страниц',
      websiteIncludePrefixesLabel: 'Включить префиксы URL',
      websiteIncludePrefixesPlaceholder: 'Введите префиксы через запятую',
      websiteIncludePrefixesTooltip:
        'Сканировать только URL, начинающиеся с этих префиксов пути (например, /docs, /blog)',
      websiteIntervalLabel: 'Интервал обхода',
      websiteIntervalMin: 'Минимальный интервал — {{min}} часов',
      websiteIntervalTooltip:
        'Как часто повторно обходить и синхронизировать новый контент',
      websiteLlmPromptLabel: 'LLM промпт',
      websiteLlmPromptPlaceholder:
        'Введите дополнительные инструкции для LLM (опционально)',
      fileType: 'Тип файла',
      status: 'Статус',
      websiteLlmPromptTooltip:
        'Дополнительные инструкции для LLM; применимо при режиме извлечения LLM',
      websiteMaxDepthLabel: 'Максимальная глубина сканирования',
      websiteMaxDepthMin: 'Глубина должна быть 0 или больше',
      websiteMaxDepthPlaceholder: 'Неограниченно',
      websiteMaxDepthTooltip:
        'Максимальная глубина сканирования от начального URL (0 = только главная страница, пустое = неограниченно)',
      websiteMaxPagesLabel: 'Максимальное количество страниц',
      websiteMaxPagesMin: 'Количество страниц должно быть больше 0',
      websiteMaxPagesPlaceholder: 'Без ограничений',
      websiteMaxPagesTooltip:
        'Максимальное количество страниц для сканирования',
      websiteSourceTitle: 'Источник: сайт',
      websiteTabsAdvanced: 'Дополнительно',
      websiteTabsMain: 'Основные настройки',
      websiteUrlInvalid: 'Пожалуйста, введите корректный URL',
      websiteUrlLabel: 'URL сайта',
      websiteUrlRequired: 'Пожалуйста, введите URL сайта',
      Parse: 'Парсинг',
      chunkMethodTab: 'Метод фрагментации',
      created: 'Создано',
      general: 'Общие',
      keywordSimilarityWeight: 'Вес сходства ключевых слов',
      keywordSimilarityWeightTip:
        'Устанавливает вес сходства ключевых слов в комбинированной оценке схожести, используемой с косинусным сходством векторов или оценкой реранкинга. Сумма двух весов должна равняться 1.0.',
      learnMore: 'Узнать больше',
      noTestResultsForNotRuned:
        'Тест еще не запущен. Результаты появятся здесь.',
      noTestResultsForRuned:
        'Релевантные результаты не найдены. Попробуйте скорректировать запрос или параметры.',
      retrievalTesting: 'Тестирование поиска',
      retrievalTestingDescription:
        'Проведите тест поиска, чтобы проверить, может ли Flexar извлекать нужный контент для LLM.',
      testResults: 'Результаты теста',
      testSetting: 'Настройки теста',
      metadata: {
        selectFiles: 'Выбрано {{count}} файлов',
        type: 'Тип',
        fieldNameInvalid:
          'Имя поля может содержать только буквы или подчёркивания.',
        builtIn: 'Встроенное',
        generation: 'Генерация',
        toMetadataSetting: 'Настройки генерации',
        toMetadataSettingTip:
          'Настройте авто-метаданные в разделе «Конфигурация».',
        descriptionTip:
          'Укажите описания или примеры, чтобы направить LLM при извлечении значений для этого поля. Если оставить пустым, будет использоваться имя поля.',
        restrictDefinedValuesTip:
          'Режим перечисления: ограничивает извлечение LLM только предустановленными значениями. Задайте значения ниже.',
        valueExists:
          'Значение уже существует. Подтвердите объединение дубликатов и всех связанных файлов.',
        fieldNameExists:
          'Имя поля уже существует. Подтвердите объединение дубликатов и всех связанных файлов.',
        valueSingleExists:
          'Значение уже существует. Подтвердите объединение дубликатов.',
        fieldSingleNameExists:
          'Имя поля уже существует. Подтвердите объединение дубликатов.',
        fieldExists: 'Поле уже существует.',
        fieldSetting: 'Настройки поля',
        changesAffectNewParses:
          'Изменения применяются только к новым парсингам.',
        restrictDefinedValues: 'Ограничить заданными значениями',
        metadataGenerationSettings: 'Настройки генерации метаданных',
        manageMetadata: 'Управление метаданными',
        metadata: 'Метаданные',
        values: 'Значения',
        value: 'Значение',
        action: 'Действие',
        field: 'Поле',
        description: 'Описание',
        fieldName: 'Имя поля',
        editMetadata: 'Редактировать метаданные',
        deleteWarn: 'Это {{field}} будет удалено из всех связанных файлов',
        deleteManageFieldAllWarn:
          'Это поле и все его значения будут удалены из всех связанных файлов.',
        deleteManageValueAllWarn:
          'Это значение будет удалено из всех связанных файлов.',
        deleteManageFieldSingleWarn:
          'Это поле и все его значения будут удалены из этого файла.',
        deleteManageValueSingleWarn:
          'Это значение будет удалено из этого файла.',
        deleteSettingFieldWarn:
          'Это поле будет удалено; существующие метаданные не изменятся.',
        deleteSettingValueWarn:
          'Это значение будет удалено; существующие метаданные не изменятся.',
      },
      redoAll: 'Очистить существующие фрагменты',
      applyAutoMetadataSettings:
        'Применить глобальные настройки авто-метаданных',
      parseFileTip: 'Вы уверены, что хотите выполнить парсинг?',
      parseFile: 'Обработать файл',
      cancelParsing: 'Отменить парсинг',
      emptyMetadata: 'Нет метаданных',
      metadataField: 'Поле метаданных',
      systemAttribute: 'Системный атрибут',
      enableChildrenDelimiter: 'Дочерние фрагменты используются для поиска',
      childrenDelimiter: 'Разделитель текста',
      childrenDelimiterTip:
        'Разделитель может состоять из одного или нескольких спецсимволов. Для нескольких символов укажите их в обратных кавычках (``). Например, при настройке \\n`##`; текст будет разделяться по переносам строк, двойному решётке (##) и точке с запятой.',
    },
    knowledgeConfiguration: {
      buildItFromScratch: 'Создать с нуля',
      builtIn: 'Встроенный',
      dataFlow: 'Конвейер',
      dataFlowPlaceholder: 'Выберите конвейер.',
      dataPipeline: 'Конвейер загрузки',
      default: 'По умолчанию',
      deleteGenerateModalContent:
        '\n' +
        "        <p>Удаление результата <strong class='text-text-primary'>{{type}}</strong> уберет все производные сущности и связи из этой базы знаний.\n" +
        '        Исходные файлы останутся нетронутыми.<p>\n' +
        '        <br/>\n' +
        '        Вы хотите продолжить?\n' +
        '      ',
      eidtLinkDataPipeline: 'Редактировать конвейер загрузки',
      enableAutoGenerate: 'Включить автогенерацию',
      extractKnowledgeGraph: 'Извлечь граф знаний',
      extractRaptor: 'Извлечь Raptor',
      fileFilter: 'Фильтр файлов',
      fileFilterTip: '',
      filterPlaceholder: 'введите фильтр',
      linkDataPipeline: 'Привязать конвейер загрузки',
      linkPipelineSetTip:
        'Управление связкой конвейера загрузки с базой знаний',
      manualSetup: 'Выбрать конвейер',
      parseType: 'Тип парсинга',
      setDefault: 'Сделать по умолчанию',
      setDefaultTip: '',
      teamPlaceholder: 'Выберите команду.',
      tocExtraction: 'Извлечение оглавления',
      tocExtractionTip:
        "Для существующих фрагментов создать иерархическое оглавление (по одному на файл). В запросах при включении 'Извлечение оглавления' модель выберет пункты оглавления, релевантные вопросу пользователя, чтобы найти связанные фрагменты и повысить их вес. Это имитация того, как люди ищут информацию в книгах.",
      titleDescription:
        'Обновите конфигурацию базы знаний, особенно метод фрагментации.',
      name: 'Название базы знаний',
      photo: 'Изображение базы знаний',
      photoTip: 'Макс. размер файла 4 МБ',
      description: 'Описание',
      language: 'Язык документов',
      languageMessage: 'Укажите язык!',
      languagePlaceholder: 'Укажите язык!',
      permissions: 'Права доступа',
      embeddingModel: 'Модель эмбеддинга',
      chunkTokenNumber: 'Рекомендуемый размер фрагмента',
      chunkTokenNumberMessage: 'Укажите количество токенов для текста',
      embeddingModelTip:
        'Модель эмбеддинга по умолчанию. Не может быть изменена после создания фрагментов.',
      permissionsTip:
        "При установке 'Команда' все участники смогут управлять базой знаний.",
      chunkTokenNumberTip:
        'Устанавливает порог токенов для создания фрагмента. Сегменты с меньшим количеством токенов объединяются до превышения порога.',
      chunkMethod: 'Метод фрагментации',
      chunkMethodTip: 'См. подсказки справа.',
      upload: 'Загрузить',
      english: 'Английский',
      chinese: 'Китайский',
      portugueseBr: 'Португальский (Бразилия)',
      embeddingModelPlaceholder: 'Выберите модель эмбеддинга.',
      chunkMethodPlaceholder: 'Выберите метод фрагментации.',
      save: 'Сохранить',
      me: 'Только я',
      team: 'Команда',
      team_readonly: 'Команда (только чтение)',
      cancel: 'Отмена',
      methodTitle: 'Описание метода фрагментации',
      methodExamples: 'Примеры',
      methodExamplesDescription: 'Скриншоты для пояснения:',
      dialogueExamplesTitle: 'просмотр',
      methodEmpty: 'Здесь будет визуальное объяснение категорий баз знаний',
      book:
        '<p>Поддерживаемые форматы: <b>DOCX, PDF, TXT</b>.</p><p>\n' +
        '      Для PDF укажите <i>диапазон страниц</i>.</p>',
      laws:
        '<p>Поддерживаемые форматы: <b>DOCX, PDF, TXT</b>.</p><p>\n' +
        '      Юридические документы обрабатываются с учетом их структуры.\n' +
        '      </p><p>\n' +
        "      Фрагменты соответствуют уровню 'СТАТЬИ'.\n" +
        '      </p>',
      manual:
        '<p>Только <b>PDF</b>.</p><p>\n' +
        '      Использует заголовки разделов как базовые единицы фрагментации.\n' +
        '      </p>',
      naive:
        '<p>Поддерживаемые форматы: <b>MD, MDX, DOCX, XLSX, XLS, PPT, PDF, TXT, JPEG, JPG, PNG, TIF, GIF, CSV, JSON, EML, HTML</b>.</p>\n' +
        "      <p>'Простой' метод фрагментации: </p>\n" +
        '      <p>\n' +
        '      <li>Использует модель для разделения текста на сегменты.</li>\n' +
        '      <li>Объединяет соседние сегменты до превышения порога токенов.</li></p>',
      paper:
        '<p>Только <b>PDF</b>.</p><p>\n' +
        '      Статьи разделяются по разделам (аннотация, 1.1, 1.2 и т.д.). </p><p>\n' +
        '      Увеличивает контекст для ИИ-диалогов и вычислительные затраты.\n' +
        '      </p>',
      presentation:
        '<p>Поддерживаемые форматы: <b>PDF, PPTX</b>.</p><p>\n' +
        '      Каждый слайд обрабатывается как отдельный фрагмент.</p>',
      qa:
        '\n' +
        '      <p>\n' +
        '      Форматы: <b>XLSX, CSV/TXT</b>.\n' +
        '    </p>\n' +
        '    <li>\n' +
        '      <b>XLSX/XLS</b>: два столбца без заголовков (вопросы и ответы).\n' +
        '    </li>\n' +
        '    <li>\n' +
        '      <b>CSV/TXT</b>: UTF-8 с разделителем TAB.\n' +
        '    </li>\n' +
        '      ',
      resume:
        '<p>Форматы: <b>DOCX, PDF, TXT</b>.\n' +
        '      </p><p>\n' +
        '      Резюме структурируются для удобства поиска.\n' +
        '      </p>\n' +
        '      ',
      table:
        '<p>Форматы: <b>XLSX, CSV/TXT</b>.</p><p>\n' +
        '      Требования:\n' +
        '      <ul>\n' +
        '    <li>Для CSV/TXT используйте <em><b>TAB</b></em> как разделитель.</li>\n' +
        '    <li>Первая строка - заголовки столбцов.</li>\n' +
        '    <li>Заголовки должны быть осмысленными.</li>\n' +
        '    <li>Каждая строка - отдельный фрагмент.</li>\n' +
        '    </ul>',
      picture:
        '\n' +
        '    <p>Поддерживаются изображения (видео - скоро).</p><p>\n' +
        '    Использует OCR для извлечения текста и визуальную LLM для описаний.\n' +
        '    </p>',
      one:
        '\n' +
        '    <p>Форматы: <b>DOCX, XLSX, XLS, PDF, TXT</b>.\n' +
        '    </p><p>\n' +
        '    Весь документ обрабатывается как один фрагмент.\n' +
        '    </p>',
      knowledgeGraph:
        '<p>Форматы: <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML</b>\n' +
        '\n' +
        "<p>Использует 'Простой'/'Общий' метод фрагментации.</p>\n" +
        '<p>Фрагменты передаются в LLM для извлечения сущностей и связей.</p>\n' +
        '<p>Установите <b>Типы сущностей</b>.</p>',
      tag:
        "<p>База знаний 'Тег' служит набором тегов. Другие базы используют её для тегирования фрагментов.</p>\n" +
        '<p>Набор тегов <b>НЕ</b> участвует непосредственно в RAG-процессе.</p>\n' +
        '<p>Каждый фрагмент - пара описание-тег.</p>\n' +
        '<p>Форматы: <b>XLSX, CSV/TXT</b>.</p>\n' +
        '<p><b>XLSX</b>: два столбца без заголовков (описание и тег).</p>\n' +
        '<p><b>CSV/TXT</b>: UTF-8 с разделителем TAB.</p>\n' +
        '<p>В столбце тегов используйте <b>запятую</b> для разделения тегов.</p>\n',
      useRaptor: 'Использовать RAPTOR',
      useRaptorTip: 'Включите RAPTOR для многошаговых вопросно-ответных задач.',
      prompt: 'Промпт',
      promptTip: 'Опишите задачу для LLM, укажите формат ответа и требования.',
      promptMessage: 'Требуется промпт',
      promptText:
        'Пожалуйста, обобщите следующие абзацы. Будьте внимательны с числами, не выдумывайте. Абзацы:\n' +
        '      {cluster_content}\n' +
        'Выше представлен контент для обобщения.',
      maxToken: 'Макс. токенов',
      maxTokenTip:
        'Максимальное количество токенов на суммаризирующий фрагмент.',
      maxTokenMessage: 'Требуется макс. токенов',
      threshold: 'Порог',
      thresholdTip: 'Минимальное сходство для группировки фрагментов в RAPTOR.',
      thresholdMessage: 'Требуется порог',
      maxCluster: 'Макс. кластеров',
      maxClusterTip: 'Максимальное количество кластеров.',
      maxClusterMessage: 'Требуется макс. кластеров',
      randomSeed: 'Случайное зерно',
      randomSeedMessage: 'Требуется случайное зерно',
      entityTypes: 'Типы сущностей',
      vietnamese: 'Вьетнамский',
      pageRank: 'PageRank',
      pageRankTip:
        'Назначьте более высокий PageRank определенным базам знаний для повышения рейтинга их фрагментов.',
      tagName: 'Тег',
      frequency: 'Частота',
      searchTags: 'Поиск тегов',
      tagCloud: 'Облако',
      tagTable: 'Таблица',
      tagSet: 'Наборы тегов',
      tagSetTip:
        '\n' +
        '     <p> Выберите одну или несколько баз знаний тегов для автоматического тегирования фрагментов.</p>\n' +
        '<p>Запрос пользователя также будет автоматически тегирован.</p>\n' +
        '<p>Отличие авто-тегов от авто-ключевых слов:</p>\n' +
        '<ul>\n' +
        '  <li>Теги - закрытое множество, ключевые слова - открытое.</li>\n' +
        '  <li>Авто-ключевые слова требуют значительных ресурсов LLM.</li>\n' +
        '</ul>\n' +
        '      ',
      topnTags: 'Топ-N Тегов',
      tags: 'Теги',
      addTag: 'Добавить тег',
      useGraphRag: 'Извлечь граф знаний',
      useGraphRagTip:
        'Постройте граф знаний для улучшения многошаговых вопросно-ответных задач.',
      graphRagMethod: 'Метод',
      graphRagMethodTip:
        'Легкий: (По умолчанию) Использует промпты от github.com/HKUDS/LightRAG. Меньше токенов и ресурсов.</br>\n' +
        '        Общий: Использует промпты от github.com/microsoft/graphrag',
      resolution: 'Разрешение сущностей',
      resolutionTip:
        "Включите для объединения схожих сущностей (например, '2025' и 'год 2025').",
      community: 'Генерация отчетов сообществ',
      communityTip:
        'Генерирует сводки для кластеров связанных сущностей в графе знаний.',
      autoParse: 'Авто-парсинг',
      baseInfo: 'Основная информация',
      dataSource: 'Источник данных',
      editLinkDataPipeline: 'Редактировать пайплайн обработки',
      generationScope: 'Область генерации',
      generationScopeTip:
        'Определяет, генерируется ли RAPTOR для всего набора данных или для одного файла.',
      globalIndex: 'Глобальный индекс',
      imageTableContextWindow: 'Окно контекста изображения и таблицы',
      imageTableContextWindowTip:
        'Захватывает N токенов текста выше и ниже изображения и таблицы, чтобы дать более богатый контекст.',
      linkDataSource: 'Связать источник данных',
      linkSourceSetTip:
        'Управление связью источника данных с этим набором данных',
      paddleocrAccessToken: 'Токен доступа AI Studio',
      paddleocrAccessTokenPlaceholder: 'Ваш токен AI Studio (необязательно)',
      paddleocrAccessTokenTip: 'Токен доступа к API PaddleOCR (необязательно)',
      paddleocrAlgorithm: 'Алгоритм PaddleOCR',
      paddleocrAlgorithmTip: 'Алгоритм, используемый для обработки PaddleOCR',
      paddleocrApiUrl: 'URL API PaddleOCR',
      paddleocrApiUrlPlaceholder:
        'Например: https://paddleocr-server.com/layout-parsing',
      paddleocrApiUrlTip: 'URL конечной точки API сервиса PaddleOCR',
      paddleocrModelNamePlaceholder: 'Например: paddleocr-среда-1',
      paddleocrOptions: 'Параметры PaddleOCR',
      paddleocrSelectAlgorithm: 'Выбрать алгоритм',
      rebuildTip:
        'Повторно загружает файлы из связанного источника данных и снова их парсит.',
      scopeDataset: 'Датасет',
      scopeSingleFile: 'Один файл',
      theDocumentBeingParsedCannotBeDeleted:
        'Обрабатываемый документ нельзя удалить',
      globalIndexModelTip:
        'Используется для генерации графов знаний, RAPTOR, авто-метаданных, авто-ключевых слов и авто-вопросов. Качество модели влияет на качество генерации.',
      globalIndexModel: 'Модель индексации',
      settings: 'Настройки',
      autoMetadataTip:
        'Автоматическая генерация метаданных. Применяется к новым файлам при парсинге. Существующие файлы требуют повторного парсинга для обновления (фрагменты сохраняются). Учтите, что модель индексации из раздела «Конфигурация» потребует дополнительных токенов.',
      autoMetadata: 'Авто-метаданные',
      mineruOptions: 'Параметры MinerU',
      mineruParseMethod: 'Метод парсинга',
      mineruParseMethodTip:
        'Метод парсинга PDF: auto (автоопределение), txt (извлечение текста), ocr (оптическое распознавание символов)',
      mineruFormulaEnable: 'Распознавание формул',
      mineruFormulaEnableTip:
        'Включить распознавание формул. Примечание: может работать некорректно с документами на кириллице.',
      mineruTableEnable: 'Распознавание таблиц',
      mineruTableEnableTip: 'Включить распознавание и извлечение таблиц.',
      overlappedPercent: 'Процент перекрытия (%)',
      lastWeek: 'за последнюю неделю',
    },
    chunk: {
      chunk: 'Фрагмент',
      bulk: 'Пакетно',
      selectAll: 'Выбрать все',
      enabledSelected: 'Включить выбранные',
      disabledSelected: 'Отключить выбранные',
      deleteSelected: 'Удалить выбранные',
      search: 'Поиск',
      all: 'Все',
      enabled: 'Включен',
      disabled: 'Отключен',
      keyword: 'Ключевое слово',
      function: 'Функция',
      chunkMessage: 'Введите значение!',
      full: 'Полный текст',
      ellipse: 'Сокращенный',
      graph: 'Граф знаний',
      mind: 'Ментальная карта',
      question: 'Вопрос',
      questionTip:
        'Если есть заданные вопросы, эмбеддинг фрагмента будет основан на них.',
      openInConfluence: 'Открыть в Confluence',
      openInTelegram: 'Открыть в Telegram',
      openOnWebsite: 'Открыть на сайте',
      openOriginal: 'Открыть оригинал',
      chunkResult: 'Результат фрагментации',
      chunkResultTip:
        'Просмотр сегментов, используемых для эмбеддинга и поиска.',
      enable: 'Включить',
      disable: 'Отключить',
      delete: 'Удалить',
      type: 'Тип',
      docType: {
        image: 'Изображение',
        table: 'Таблица',
        text: 'Текст',
      },
      image: 'Изображение',
      imageUploaderTitle:
        'Загрузите новое изображение для обновления этого фрагмента',
    },
    chat: {
      newConversation: 'Новый диалог',
      createAssistant: 'Создать ассистента',
      assistantSetting: 'Настройки ассистента',
      promptEngine: 'Промпт-движок',
      modelSetting: 'Настройки модели',
      chat: 'Чат',
      newChat: 'Новый чат',
      send: 'Отправить',
      attachFile: 'Прикрепить файл',
      stopGenerating: 'Остановить генерацию',
      sendPlaceholder: 'Сообщение ассистенту...',
      chatConfiguration: 'Конфигурация чата',
      chatConfigurationDescription:
        'Настройте чат-ассистента для ваших наборов данных (баз знаний)! 💕',
      assistantName: 'Имя ассистента',
      assistantNameMessage: 'Требуется имя ассистента',
      namePlaceholder: 'например, Резюме Jarvis',
      assistantAvatar: 'Аватар ассистента',
      language: 'Язык',
      emptyResponse: 'Пустой ответ',
      emptyResponseTip:
        'Ответ, если в базах знаний не найдено релевантной информации.',
      emptyResponseMessage:
        'Срабатывает, если ничего не найдено. Очистите поле, если не выбраны базы знаний.',
      setAnOpener: 'Приветственное сообщение',
      setAnOpenerInitial: 'Привет! Я ваш ассистент, чем могу помочь?',
      setAnOpenerTip: 'Установите приветствие для пользователей.',
      knowledgeBases: 'Базы знаний',
      knowledgeBasesMessage: 'Выберите',
      knowledgeBasesTip:
        'Выберите базы знаний для ассистента. Пустые базы не отображаются.',
      system: 'Системный промпт',
      systemInitialValue:
        'Вы умный ассистент. Обобщите контент базы знаний, чтобы ответить на вопрос. Подробно перечислите данные из базы знаний. Если контент не релевантен, включите фразу "Ответ не найден в базе знаний!". Учитывайте историю диалога.\n' +
        '      База знаний:\n' +
        '      {knowledge}\n' +
        '      Выше представлена база знаний.',
      systemMessage: 'Введите текст!',
      systemTip:
        'Инструкции для LLM: роль, длина, тон и язык ответов. Используйте //no_thinking для отключения рассуждений.',
      topN: 'Топ N',
      topNTip: "Выбирает 'Топ N' фрагментов из найденных.",
      variable: 'Переменная',
      variableTip:
        'Переменные делают системные промпты более гибкими. {knowledge} - зарезервированная переменная для найденных фрагментов.',
      add: 'Добавить',
      key: 'Ключ',
      optional: 'Опционально',
      operation: 'Действие',
      model: 'Модель',
      modelTip: 'Модель чата',
      modelMessage: 'Выберите!',
      modelEnabledTools: 'Включенные инструменты',
      modelEnabledToolsTip:
        'Выберите инструменты для модели чата. Эффективно только для моделей, поддерживающих вызов инструментов.',
      freedom: 'Свобода',
      improvise: 'Импровизация',
      precise: 'Точность',
      balance: 'Баланс',
      freedomTip:
        "Сокращенная настройка 'Температуры', 'Top P', 'Штрафа за присутствие' и 'Штрафа за частоту'.",
      temperature: 'Температура',
      temperatureMessage: 'Требуется температура',
      temperatureTip: 'Контролирует случайность предсказаний модели.',
      topP: 'Top P',
      topPMessage: 'Требуется Top P',
      topPTip:
        'Устанавливает порог для выбора наиболее вероятных слов (ядерная выборка).',
      presencePenalty: 'Штраф за присутствие',
      presencePenaltyMessage: 'Требуется штраф за присутствие',
      presencePenaltyTip: 'Штрафует слова, уже появившиеся в диалоге.',
      frequencyPenalty: 'Штраф за частоту',
      frequencyPenaltyMessage: 'Требуется штраф за частоту',
      frequencyPenaltyTip:
        'Уменьшает тенденцию модели повторять одни и те же слова.',
      maxTokens: 'Макс. токенов',
      maxTokensMessage: 'Требуется макс. токенов',
      maxTokensTip:
        'Максимальная длина вывода модели в токенах. По умолчанию 512.',
      maxTokensInvalidMessage: 'Введите корректное число для Макс. токенов.',
      maxTokensMinMessage: 'Макс. токенов не может быть меньше 0.',
      quote: 'Показать источник',
      quoteTip: 'Отображать исходный текст как ссылку.',
      selfRag: 'Self-RAG',
      selfRagTip: 'См.: https://huggingface.co/papers/2310.11511',
      overview: 'ID чата',
      pv: 'Количество сообщений',
      uv: 'Количество активных пользователей',
      speed: 'Скорость вывода токенов',
      tokens: 'Потрачено токенов',
      round: 'Количество взаимодействий',
      thumbUp: 'Удовлетворенность клиентов',
      preview: 'Предпросмотр',
      embedded: 'Встроенный',
      serviceApiEndpoint: 'Конечная точка API сервиса',
      apiKey: 'API КЛЮЧ',
      apiReference: 'Документация API',
      dateRange: 'Диапазон дат:',
      backendServiceApi: 'API Сервер',
      createNewKey: 'Создать новый ключ',
      tokenName: 'Название',
      tokenNamePlaceholder: 'Название ключа (необязательно)',
      created: 'Создан',
      action: 'Действие',
      embedModalTitle: 'Встроить на веб-страницу',
      comingSoon: 'Скоро будет',
      fullScreenTitle: 'Полное встраивание',
      fullScreenDescription:
        'Встройте следующий iframe в нужное место вашего сайта',
      partialTitle: 'Частичное встраивание',
      extensionTitle: 'Расширение Chrome',
      tokenError: 'Сначала создайте API ключ.',
      betaError:
        'Сначала получите API ключ Flexar на странице системных настроек.',
      searching: 'Поиск',
      thinking: 'Думает', // Flexar: ожидание ответа — модель думает, а не ищет
      noResponse: 'Не удалось получить ответ. Попробуйте еще раз.',
      retryAnswer: 'Повторить', // Flexar: действие на неудавшемся ответе
      // Flexar: у поставщика модели кончились оплаченные средства — сказать, что делать
      errorInsufficientFunds: 'Закончились средства на оплату модели',
      errorInsufficientFundsHint:
        'Сообщите администратору — после пополнения счёта повторите запрос.',
      emptyStateTitle: 'Чем помочь?', // Flexar: первый экран пустого чата
      thinkingCollapsed: 'Думаю',
      // Flexar: действие запускает поиск по источникам, а не настройку размышления модели; название должно это различать.
      thinkAction: 'Глубокий поиск',
      noConversations: 'Пока нет диалогов',
      // Flexar: composer actions and retrieval-mode explanation.
      voiceInput: 'Голосовой ввод',
      stopRecording: 'Остановить запись',
      removeAttachment: 'Удалить вложение',
      searchInternet: 'Поиск в интернете',
      thinkTooltip:
        'Глубокий поиск: многошаговый поиск по источникам. Ответ может занять больше времени.',
      thinkRequired: 'Глубокий поиск включён в настройках ассистента.',
      showSidebar: 'Показать диалоги',
      hideSidebar: 'Скрыть диалоги',
      conversationActions: 'Действия с диалогом',
      presentationSlides: 'Слайды',
      presentationCustom: 'Другое',
      presentationLanguage: 'Язык',
      presentationLanguage_auto: 'Авто',
      presentationLanguage_Russian: 'Русский',
      presentationLanguage_English: 'Английский',
      thoughtFor: 'Думал',
      secondsShort: 'сек',
      minutesShort: 'мин', // Flexar: длинные размышления считаем минутами
      parsing: 'Обработка',
      uploading: 'Загрузка',
      uploadFailed: 'Ошибка загрузки',
      regenerate: 'Повторить',
      read: 'Читать содержимое',
      like: 'Хороший ответ', // Flexar: подписи строки действий у сообщения
      dislike: 'Плохой ответ',
      prompt: 'Показать промпт',
      messageLog: 'Журнал выполнения',
      tts: 'Текст в речь',
      ttsTip:
        'Выберите модель TTS на странице настроек перед включением этой опции.',
      piiGuard: 'Маскировать персональные данные',
      piiGuardTip:
        'Заменять обнаруженные персональные данные (телефоны, email, имена и т. п.) на плейсхолдеры перед отправкой запроса во внешнюю языковую модель и восстанавливать их в ответе. Действует совместно с серверной настройкой защиты.',
      piiGuardUnavailableTip:
        'Маскирование недоступно: сервис защиты персональных данных не настроен на сервере. Как только администратор его настроит, переключатель станет доступен.',
      relatedQuestion: 'Связанный вопрос',
      answerTitle: 'О',
      multiTurn: 'Многоходовая оптимизация',
      multiTurnTip:
        'Оптимизирует пользовательские запросы с использованием контекста многоходового диалога. Требует дополнительных токенов LLM.',
      howUseId: 'Как использовать ID чата?',
      description: 'Описание ассистента',
      descriptionPlaceholder: 'например, Чат-ассистент для резюме.',
      useKnowledgeGraph: 'Использовать граф знаний',
      useKnowledgeGraphTip:
        'Использовать графы знаний для многоходовых вопросов. Увеличивает время поиска.',
      keyword: 'Анализ ключевых слов',
      keywordTip:
        'Использовать LLM для анализа вопросов пользователя и извлечения ключевых слов. Увеличивает время ответа.',
      languageTip:
        'Переписывает предложения на выбранном языке или использует язык последнего вопроса.',
      avatarHidden: 'Скрыть аватар',
      locale: 'Локаль',
      selectLanguage: 'Выберите язык',
      reasoning: 'Рассуждение',
      reasoningTip:
        'Включите рабочий процесс рассуждений для сложных вопросов, как в Deepseek-R1 или OpenAI o1.',
      tavilyApiKeyTip:
        'Если API ключ установлен, будут использоваться веб-поиски на основе Tavily.',
      tavilyApiKeyMessage: 'Введите ваш Tavily API Key',
      tavilyApiKeyHelp: 'Как получить?',
      crossLanguage: 'Межъязыковый поиск',
      crossLanguageTip:
        'Выберите один или несколько языков для межъязыкового поиска.',
      createChat: 'Создать чат',
      botToken: 'Токен бота',
      botTokenFormat: 'Токен выглядит как:',
      botTokenPlaceholder: 'Введите токен бота...',
      botTokenRequired: 'Требуется токен бота',
      botTokenTooltipEnd:
        'в Telegram\n2. Отправьте /newbot или /mybots\n3. Скопируйте токен из сообщения',
      botTokenTooltipStart: 'Как получить токен бота:\n1. Напишите',
      botTokenUpdatePlaceholder: 'Введите новый токен для обновления...',
      currentBotToken: 'Текущий токен',
      linkBot: 'Привязать',
      linkBotFailed: 'Не удалось привязать бота',
      linkBotSuccess: 'Бот привязан',
      linkTelegramBot: 'Привязать Telegram бота',
      tokenConfiguredHint:
        'Токен настроен. Введите новый токен для обновления.',
      unlinkBot: 'Отвязать',
      unlinkBotSuccess: 'Бот отвязан',
      updateBot: 'Обновить',
      addCondition: 'Добавить условие',
      applyModelConfigs: 'Применить конфигурации моделей',
      cancel: 'Отмена',
      chatApps: 'Чат-приложения',
      chatSetting: 'Настройки',
      conditions: 'Условия',
      conversations: 'Диалоги',
      custom: 'Пользовательский',
      exit: 'Выход',
      // Flexar: короткий placeholder оставляет больше места сообщению на узком экране.
      messagePlaceholder: 'Сообщение…',
      meta: {
        disabled: 'Отключено',
        auto: 'Автоматически',
        automatic: 'Автоматически',
        manual: 'Вручную',
        semi_auto: 'Полуавтоматически',
      },
      metadata: 'Метаданные',
      metadataTip:
        'Фильтрация метаданных — это процесс использования атрибутов метаданных (таких как теги, категории или разрешения доступа) для уточнения и контроля поиска релевантной информации в системе.',
      multipleModels: 'Сравнить модели',
      // Flexar: «Чат с моделью» — выбор модели в окне чата
      modelPicker: {
        label: 'Модель',
        more: 'Ещё {{count}}',
        searchPlaceholder: 'Поиск модели',
        empty: 'Ничего не найдено',
        quickPicks: 'Быстрый выбор',
        hostingShortLocal: 'свои серверы',
        hostingShortRu: 'Россия',
        hostingShortForeign: 'за рубежом',
        hostingRu: 'обработка в России',
        hostingLocal: 'на своих серверах',
        hostingForeign: 'обработка за рубежом',
        // Flexar: предупреждение перед выбором модели, которая может обрабатывать запросы за рубежом
        crossBorderTitle: 'Трансграничная передача данных',
        crossBorderForeign:
          'Модель «{{model}}» обрабатывает запросы на серверах за пределами России. С каждым сообщением ей передаются текст, история этой беседы и прикреплённые файлы.',
        crossBorderUnknown:
          'Поставщик модели «{{model}}» не сообщает, где обрабатываются запросы, — они могут уходить на серверы за пределами России. С каждым сообщением передаются текст, история этой беседы и прикреплённые файлы.',
        crossBorderAdvice:
          'Не отправляйте этой модели персональные данные, коммерческую тайну и другие сведения, которые нельзя передавать за рубеж.',
        crossBorderConfirm: 'Выбрать модель',
      },
      // Flexar: стоимость ответа (PILOTFLEXARBR-44)
      // Flexar: время реплики (PILOTFLEXARBR-44)
      messageTime: {
        answeredAt: 'Ответ готов {{value}}',
      },
      day: {
        today: 'Сегодня',
        yesterday: 'Вчера',
      },
      cost: {
        // «выход 34 токенов» — неверное согласование; число меняется, поэтому слово вынесено в метку
        tokensDetail: 'Токены: вход {{prompt}} · выход {{completion}}',
        cached: 'из них из кеша: {{tokens}}',
        estimate: 'оценка',
        aborted: 'ответ прерван',
        // Flexar: итог по беседе (PILOTFLEXARBR-44)
        total: 'Беседа:',
        // Flexar: то же слово без двоеточия — для скринридера, он читает его вслух
        totalLabel: 'Беседа',
        totalAnswers_one: '{{count}} ответ',
        totalAnswers_few: '{{count}} ответа',
        totalAnswers_many: '{{count}} ответов',
        totalPartial: '{{priced}} из {{answers}} ответов с ценой',
        reported: 'По данным провайдера',
        estimated: 'Оценка Flexar: провайдер не сообщил расход',
      },
      modelChoices: {
        title: 'Выбор модели в чате',
        scopeOff: 'Без выбора',
        scopeOffTip: 'Чат работает на модели ассистента.',
        scopePinned: 'Только закреплённые',
        scopePinnedTip: 'Ровно те модели, что закреплены ниже.',
        scopeTeam: 'Весь каталог команды',
        scopeTeamTip:
          'Все модели, которые команда может запускать. Закреплённые становятся быстрыми кнопками, остальные — в меню с поиском.',
        boundary: 'Где можно обрабатывать',
        boundaryLocal: 'Только свои серверы',
        boundaryLocalTip:
          'Модели на инфраструктуре команды. Ничего не уходит наружу.',
        boundaryRu: 'Свои серверы и Россия',
        boundaryRuTip:
          'Плюс провайдеры, которые обрабатывают запросы в России. Кто о маршруте молчит — не подходит.',
        boundaryAny: 'Без ограничений',
        boundaryAnyTip:
          'Плюс зарубежные провайдеры и те, кто маршрут не раскрывает.',
        pinned: 'Закреплённые',
        pinnedTip:
          'Быстрые кнопки в чате, в этом порядке. Подпись необязательна — название собирается из id модели.',
        empty: 'Ничего не закреплено.',
        add: 'Закрепить модель',
        labelAria: 'Название модели в чате',
        reorder: 'Переместить: тащите или стрелками',
        remove: 'Открепить',
      },
      permissions: 'Права доступа',
      me: 'Только я',
      team: 'Команда',
      onlyOwner: 'Только владелец',
      teamReadonly: 'Команда (только чтение)',
      tocEnhance: 'Усиление по оглавлению',
      tocEnhanceTip:
        'Во время парсинга было сгенерировано оглавление (см. опцию «Извлечение оглавления» в общем методе). Это позволяет модели возвращать пункты оглавления, релевантные запросу пользователя, использовать их для выбора связанных фрагментов и повышать их вес при сортировке, имитируя то, как люди ищут информацию в книге.',
      metadataKeys: 'Элементы для фильтрации',
      batchDeleteSessions: 'Удалить сессии',
      deleteSelectedConfirm: 'Удалить выбранные сессии ({{count}})?',
    },
    setting: {
      dbHost: 'Хост',
      dbPort: 'Порт',
      dbDatabase: 'База данных',
      dbUsername: 'Имя пользователя',
      dbPassword: 'Пароль',
      dbSqlQuery: 'SQL запрос',
      dbContentColumns: 'Колонки содержимого',
      // Placeholders
      placeholderAdminEmail: 'admin@example.com',
      placeholderMultipleEmails: 'user1@example.com,user2@example.com',
      placeholderSharedFolderUrls:
        'https://drive.google.com/drive/folders/XXXXX,https://drive.google.com/drive/folders/YYYYY',
      placeholderMoodleUrl: 'https://moodle.example.com',
      placeholderJiraBaseUrl: 'https://your-domain.atlassian.net',
      placeholderJiraProjectKey: 'RAGFlow',
      placeholderJiraJql: 'project = RAG AND updated >= -7d',
      placeholderJiraUserEmail: 'you@example.com',
      placeholderWebdavUrl: 'https://webdav.example.com',
      placeholderWebdavRemotePath: '/',
      placeholderDropboxBatchSize: 'По умолчанию 2',
      placeholderBoxFolderId: 'По умолчанию root',
      placeholderGitlabUrl: 'https://gitlab.com',
      placeholderSeafileUrl: 'https://seafile.example.com',
      placeholderSeafileBatchSize: '100',
      placeholderDbQuery: 'Оставьте пустым, чтобы загрузить все таблицы',
      placeholderAwsRoleArn: 'arn:aws:iam::123456789012:role/YourRole',
      placeholderS3EndpointUrl: 'https://fsn1.your-objectstorage.com',
      placeholderContentColumns: 'title,description,content',
      editShort: 'Ред.',
      editNameTitle: 'Редактирование имени',
      editTimeZoneTitle: 'Редактирование часового пояса',
      editPasswordTitle: 'Редактирование пароля',
      setPasswordTitle: 'Установка пароля',
      passwordPlaceholder: 'Введите пароль',
      profile: 'Профиль',
      avatar: 'Аватар',
      avatarTip: 'Отображается в вашем профиле.',
      profileDescription: 'Обновите фото и личные данные.',
      maxTokens: 'Макс. токенов',
      maxTokensMessage: 'Требуется макс. токенов',
      maxTokensTip:
        'Максимальная длина вывода модели в токенах. По умолчанию 512.',
      maxTokensInvalidMessage: 'Введите корректное число для Макс. токенов.',
      maxTokensMinMessage: 'Макс. токенов не может быть меньше 0.',
      password: 'Пароль',
      passwordDescription: 'Введите текущий пароль для изменения пароля.',
      model: 'Провайдеры моделей',
      modelDescription: 'Настройте параметры моделей и API KEY.',
      notifications: 'Уведомления',
      dataSources: 'Источники данных',
      analytics: 'Аналитика',
      expenses: 'Расходы', // Flexar: PILOTFLEXARBR-44
      team: 'Команда',
      administration: 'Администрирование',
      system: 'Система',
      logout: 'Выйти',
      api: 'API',
      username: 'Имя пользователя',
      usernameMessage: 'Введите имя пользователя!',
      photo: 'Ваше фото',
      photoDescription: 'Отображается в вашем профиле.',
      colorSchema: 'Цветовая схема',
      colorSchemaMessage: 'Выберите цветовую схему!',
      colorSchemaPlaceholder: 'выберите цветовую схему',
      bright: 'Светлая',
      dark: 'Тёмная',
      timezone: 'Часовой пояс',
      timezoneMessage: 'Укажите часовой пояс!',
      timezonePlaceholder: 'выберите часовой пояс',
      email: 'Email адрес',
      emailDescription: 'После регистрации email нельзя изменить.',
      // Flexar: личная настройка показа стоимости (PILOTFLEXARBR-44)
      showChatCost: 'Стоимость ответов',
      showChatCostDescription:
        'Показывать под каждым ответом, во что он обошёлся.',
      currentPassword: 'Текущий пароль',
      currentPasswordMessage: 'Введите пароль!',
      newPassword: 'Новый пароль',
      changePassword: 'Изменить пароль',
      newPasswordMessage: 'Введите пароль!',
      newPasswordDescription:
        'Ваш новый пароль должен быть длиннее 8 символов.',
      confirmPassword: 'Подтвердите новый пароль',
      confirmPasswordMessage: 'Подтвердите пароль!',
      confirmPasswordNonMatchMessage: 'Новые пароли не совпадают!',
      cancel: 'Отмена',
      plan: 'Тариф',
      sidebarAccount: 'Аккаунт и команда',
      sidebarSystem: 'Конфигурации системы',
      promptManagement: 'Управление промптами',
      chunkMethod: 'Метод чанкинга',
      appearance: {
        title: 'Оформление',
        description:
          'Настройте фирменный цвет интерфейса. Все производные цвета вычисляются автоматически.',
        primaryColor: 'Фирменный цвет',
        preview: 'Предпросмотр',
        lightMode: 'Светлая тема',
        darkMode: 'Тёмная тема',
        previewTitle: 'Flexar',
        previewButton: 'Основной',
        previewError: 'Ошибка',
        secondaryColor: 'Акцентный цвет',
        secondaryColorTip:
          'Необязательно. Подмешивается в marble-паттерн аватаров.',
        secondaryColorPlaceholder: '#8b5cf6',
        invalidColor: 'Некорректный hex-цвет',
        branding: 'Логотип и Favicon',
        logoLabel: 'Логотип приложения',
        logoTip:
          'Квадратное изображение для сайдбара и шапки. SVG, PNG или JPG.',
        faviconLabel: 'Favicon',
        faviconTip: 'Иконка вкладки браузера. SVG, PNG или ICO.',
        save: 'Сохранить',
        reset: 'Сбросить по умолчанию',
      },
      addedModels: 'Добавленные модели',
      modelsToBeAdded: 'Модели для добавления',
      addTheModel: 'Добавить модель',
      createMultiProvider: 'Добавить fallback-конфигурацию',
      addMultiProvider: 'Добавить fallback-конфигурацию',
      configName: 'Название конфигурации',
      multiProviderNamePlaceholder: 'Введите название конфигурации',
      providers: 'Провайдеры (порядок приоритета)',
      providersPriorityTip:
        'Модели будут вызываться по порядку. Перетащите, чтобы изменить приоритет.',
      selectProviderToAdd: 'Выберите провайдера для добавления',
      minTwoProviders: 'Нужно минимум 2 провайдера',
      retryAllOnFailure: 'Повторять цикл при полном фейле',
      retryAllOnFailureTip: 'Если все провайдеры упали, начать список заново',
      maxTotalRetries: 'Максимум циклов',
      maxTotalRetriesTip: 'Сколько раз можно повторить весь список провайдеров',
      allowMixedModels: 'Разрешить разные модели (relaxed)',
      allowMixedModelsTip:
        'Если включено, провайдеры могут быть разными моделями (одинаковый тип). Нельзя для embedding/rerank.',
      multiProviderStrictTypeWarning:
        'Для {{type}} требуется одна и та же модель у всех провайдеров',
      multiProviderStrictTypeDescription: null,
      multiProviderIncompatibleModels:
        'Несовместимые модели для {{type}}: {{models}}. Все провайдеры должны быть одной и той же моделью.',
      apiKey: 'API-Ключ',
      apiKeyMessage: 'Введите API ключ (для локальных моделей игнорируйте).',
      apiKeyTip: 'API ключ можно получить у поставщика LLM.',
      showMoreModels: 'Показать модели',
      hideModels: 'Скрыть модели',
      baseUrl: 'Базовый URL',
      baseUrlTip:
        'Если ваш API ключ от OpenAI, оставьте пустым. Другие провайдеры предоставляют базовый URL с API ключом.',
      tongyiBaseUrlTip:
        'Для пользователей из Китая: не заполняйте или используйте https://dashscope.aliyuncs.com/compatible-mode/v1. Для международных пользователей: https://dashscope-intl.aliyuncs.com/compatible-mode/v1',
      tongyiBaseUrlPlaceholder:
        '(Только для международных пользователей, см. подсказку)',
      folderId: 'Folder ID',
      folderIdTip: 'Folder ID для моделей Yandex Cloud',
      folderIdPlaceholder: 'Введите Folder ID',
      modify: 'Изменить',
      systemModelSettings: 'Установить модели по умолчанию',
      chatModel: 'Модель чата',
      chatModelTip: 'Модель чата по умолчанию для новых баз знаний.',
      embeddingModel: 'Модель эмбеддинга',
      embeddingModelTip: 'Модель эмбеддинга по умолчанию для новых баз знаний.',
      img2txtModel: 'Модель Img2txt',
      img2txtModelTip: 'Модель описания изображений/видео по умолчанию.',
      sequence2txtModel: 'Модель Speech2txt',
      sequence2txtModelTip:
        'Модель ASR по умолчанию для преобразования речи в текст.',
      rerankModel: 'Модель реранкинга',
      rerankModelTip: 'Модель реранкинга фрагментов по умолчанию.',
      ttsModel: 'Модель TTS',
      ttsModelTip: 'Модель преобразования текста в речь по умолчанию.',
      workspace: 'Рабочее пространство',
      upgrade: 'Обновить',
      addLlmTitle: 'Добавить LLM',
      editLlmTitle: 'Редактировать модель {{name}}',
      editModel: 'Редактировать модель',
      modelName: 'Название модели',
      modelID: 'ID модели',
      modelUid: 'UID модели',
      modelNameMessage: 'Введите название модели!',
      modelType: 'Тип модели',
      modelTypeMessage: 'Введите тип модели!',
      addLlmBaseUrl: 'Базовый URL',
      baseUrlNameMessage: 'Введите базовый URL!',
      vision: 'Поддерживает Vision?',
      supportTools: 'Поддерживает вызов инструментов?',
      ollamaLink: 'Как интегрировать {{name}}',
      FishAudioLink: 'Как использовать FishAudio',
      TencentCloudLink: 'Как использовать TencentCloud ASR',
      volcModelNameMessage: 'Введите название модели!',
      addEndpointID: 'EndpointID модели',
      endpointIDMessage: 'Введите EndpointID модели',
      addArkApiKey: 'VOLC ARK_API_KEY',
      ArkApiKeyMessage: 'Введите ваш ARK_API_KEY',
      bedrockModelNameMessage: 'Введите название модели!',
      addBedrockEngineAK: 'ACCESS KEY',
      bedrockAKMessage: 'Введите ваш ACCESS KEY',
      addBedrockSK: 'SECRET KEY',
      bedrockSKMessage: 'Введите ваш SECRET KEY',
      bedrockRegion: 'Регион AWS',
      bedrockRegionMessage: 'Выберите!',
      'us-east-2': 'US East (Огайо)',
      'us-east-1': 'US East (Северная Вирджиния)',
      'us-west-1': 'US West (Северная Калифорния)',
      'us-west-2': 'US West (Орегон)',
      'af-south-1': 'Африка (Кейптаун)',
      'ap-east-1': 'Азиатско-Тихоокеанский регион (Гонконг)',
      'ap-south-2': 'Азиатско-Тихоокеанский регион (Хайдарабад)',
      'ap-southeast-3': 'Азиатско-Тихоокеанский регион (Джакарта)',
      'ap-southeast-5': 'Азиатско-Тихоокеанский регион (Малайзия)',
      'ap-southeast-4': 'Азиатско-Тихоокеанский регион (Мельбурн)',
      'ap-south-1': 'Азиатско-Тихоокеанский регион (Мумбаи)',
      'ap-northeast-3': 'Азиатско-Тихоокеанский регион (Осака)',
      'ap-northeast-2': 'Азиатско-Тихоокеанский регион (Сеул)',
      'ap-southeast-1': 'Азиатско-Тихоокеанский регион (Сингапур)',
      'ap-southeast-2': 'Азиатско-Тихоокеанский регион (Сидней)',
      'ap-east-2': 'Азиатско-Тихоокеанский регион (Тайбэй)',
      'ap-southeast-7': 'Азиатско-Тихоокеанский регион (Таиланд)',
      'ap-northeast-1': 'Азиатско-Тихоокеанский регион (Токио)',
      'ca-central-1': 'Канада (Центральный)',
      'ca-west-1': 'Канада Запад (Калгари)',
      'eu-central-1': 'Европа (Франкфурт)',
      'eu-west-1': 'Европа (Ирландия)',
      'eu-west-2': 'Европа (Лондон)',
      'eu-south-1': 'Европа (Милан)',
      'eu-west-3': 'Европа (Париж)',
      'eu-south-2': 'Европа (Испания)',
      'eu-north-1': 'Европа (Стокгольм)',
      'eu-central-2': 'Европа (Цюрих)',
      'il-central-1': 'Израиль (Тель-Авив)',
      'mx-central-1': 'Мексика (Центральный)',
      'me-south-1': 'Ближний Восток (Бахрейн)',
      'me-central-1': 'Ближний Восток (ОАЭ)',
      'sa-east-1': 'Южная Америка (Сан-Паулу)',
      'us-gov-east-1': 'AWS GovCloud (US-East)',
      'us-gov-west-1': 'AWS GovCloud (US-West)',
      addHunyuanSID: 'Hunyuan Secret ID',
      HunyuanSIDMessage: 'Введите ваш Secret ID',
      addHunyuanSK: 'Hunyuan Secret Key',
      HunyuanSKMessage: 'Введите ваш Secret Key',
      addTencentCloudSID: 'TencentCloud Secret ID',
      TencentCloudSIDMessage: 'Введите ваш Secret ID',
      addTencentCloudSK: 'TencentCloud Secret Key',
      TencentCloudSKMessage: 'Введите ваш Secret Key',
      SparkModelNameMessage: 'Выберите модель Spark',
      addSparkAPIPassword: 'Spark APIPassword',
      SparkAPIPasswordMessage: 'введите ваш APIPassword',
      addSparkAPPID: 'Spark APP ID',
      SparkAPPIDMessage: 'введите ваш APP ID',
      addSparkAPISecret: 'Spark APISecret',
      SparkAPISecretMessage: 'введите ваш APISecret',
      addSparkAPIKey: 'Spark APIKey',
      SparkAPIKeyMessage: 'введите ваш APIKey',
      yiyanModelNameMessage: 'Введите название модели',
      addyiyanAK: 'yiyan API KEY',
      yiyanAKMessage: 'Введите ваш API KEY',
      addyiyanSK: 'yiyan Secret KEY',
      yiyanSKMessage: 'Введите ваш Secret KEY',
      FishAudioModelNameMessage: 'Дайте имя вашей модели синтеза речи',
      addFishAudioAK: 'Fish Audio API KEY',
      addFishAudioAKMessage: 'Введите ваш API KEY',
      FishAudioAKMessage: 'Введите ваш API KEY',
      addFishAudioRefID: 'FishAudio Reference ID',
      addFishAudioRefIDMessage:
        'Введите Reference ID (оставьте пустым для модели по умолчанию).',
      FishAudioRefIDMessage:
        'Введите Reference ID (оставьте пустым для модели по умолчанию).',
      GoogleModelIDMessage: 'Введите ID модели!',
      addGoogleProjectID: 'Project ID',
      GoogleProjectIDMessage: 'Введите Project ID',
      addGoogleServiceAccountKey:
        'Service Account Key (Оставьте пустым для Application Default Credentials)',
      GoogleServiceAccountKeyMessage:
        'Введите Google Cloud Service Account Key в формате base64',
      addGoogleRegion: 'Регион Google Cloud',
      GoogleRegionMessage: 'Введите регион Google Cloud',
      modelProvidersWarn:
        "Сначала добавьте модели эмбеддинга и LLM в <b>Настройки > Провайдеры моделей</b>. Затем установите их в 'Модели по умолчанию'.",
      apiVersion: 'Версия API',
      apiVersionMessage: 'Введите версию API',
      add: 'Добавить',
      updateDate: 'Дата обновления',
      role: 'Роль',
      invite: 'Пригласить',
      agree: 'Принять',
      refuse: 'Отклонить',
      teamMembers: 'Участники команды',
      joinedTeams: 'Присоединенные команды',
      sureDelete: 'Удалить этого участника?',
      quit: 'Выйти',
      sureQuit: 'Покинуть команду?',
      secretKey: 'Секретный ключ',
      publicKey: 'Публичный ключ',
      secretKeyMessage: 'Введите секретный ключ',
      publicKeyMessage: 'Введите публичный ключ',
      hostMessage: 'Введите хост',
      configuration: 'Конфигурация',
      langfuseDescription:
        'Трассировка, оценка, управление промптами и метрики для отладки и улучшения вашего LLM-приложения.',
      viewLangfuseSDocumentation: 'Документация Langfuse',
      view: 'Просмотр',
      modelsToBeAddedTooltip:
        'Если ваш провайдер не указан, но заявляет о "совместимости с OpenAI API", выберите соответствующую карточку.',
      mcp: 'MCP',
      S3CompatibleAddressingStyleTip:
        'Требуется для S3 совместимого Storage Box. Укажите стиль адресации, совместимый с S3.\n' +
        'Пример: Virtual Hosted Style',
      S3CompatibleEndpointUrlTip:
        'Требуется для S3 совместимого Storage Box. Укажите URL конечной точки, совместимой с S3.\n' +
        'Пример: https://fsn1.your-objectstorage.com',
      addDataSourceModalTitle: 'Создайте ваш коннектор {{name}}',
      airtableDescription:
        'Подключите Airtable и синхронизируйте файлы из указанной таблицы в заданном рабочем пространстве.',
      asanaDescription:
        'Подключите Asana и синхронизируйте файлы из рабочего пространства.',
      availableModels: 'Доступные модели',
      availableSources: 'Доступные источники',
      yandex_wikiDescription:
        'Подключите Яндекс Вики для синхронизации страниц базы знаний.',
      yandexWikiOAuthToken: 'OAuth-токен',
      yandexWikiOrgId: 'ID организации',
      yandexWikiCollabOrgId: 'ID организации (X-Org-Id)',
      yandexWikiPages: 'Страницы',
      yandexWikiPagesPlaceholder:
        'По одной странице на строку: URL, slug или ID\nhomepage/team/onboarding\nhttps://wiki.yandex.ru/hr/policy\n12345',
      yandexWikiPagesTip:
        'Список страниц вики для синхронизации. По одной на строку. Поддерживаются полные URL, slug-и и числовые ID. Строки, начинающиеся с #, игнорируются.',
      yandexWikiBaseUrl: 'Базовый URL API',
      yandexWikiBaseUrlTip:
        'Переопределить стандартный URL API Яндекс Вики. Оставьте пустым для стандартного эндпоинта.',
      yandexWikiOrgIdTip:
        'ID организации в Яндекс 360. Можно оставить пустым, если настроено администратором на сервере.',
      yandexWikiCollabOrgIdTip:
        'ID организации из Яндекс 360 (используется как заголовок X-Org-Id). Можно оставить пустым, если настроено администратором.',
      yandexWikiAuthorize: 'Войти через Яндекс',
      yandexWikiReauthorize: 'Авторизоваться заново',
      yandexWikiAuthorized: 'Авторизован',
      yandexWikiWaitingAuth: 'Завершите авторизацию во всплывающем окне...',
      yandexWikiAuthSuccess: 'Авторизация в Яндекс Вики прошла успешно.',
      yandexWikiAuthFailed: 'Ошибка авторизации в Яндекс Вики.',
      availableSourcesDescription: 'Выберите источник данных для добавления',
      bitbucketDescription:
        'Подключите Bitbucket для синхронизации содержимого PR.',
      bitbucketProjectsTip:
        'Ключи проектов через запятую, например: PROJ1,PROJ2',
      bitbucketRepositorySlugsTip:
        'Слоги репозиториев через запятую, например: repo-one,repo-two',
      bitbucketTopWorkspaceTip:
        'Рабочее пространство Bitbucket для индексации (например, "atlassian" из https://bitbucket.org/atlassian/workspace )',
      bitbucketWorkspaceTip:
        'Этот коннектор проиндексирует все репозитории в рабочем пространстве.',
      // Jira field labels
      jiraBaseUrl: 'Базовый URL Jira',
      jiraProjectKey: 'Ключ проекта',
      jiraCustomJql: 'Пользовательский JQL',
      jiraBatchSize: 'Размер пакета',
      jiraIncludeComments: 'Включать комментарии',
      jiraIncludeAttachments: 'Включать вложения',
      jiraAttachmentSizeLimit: 'Лимит размера вложения (байты)',
      jiraLabelsToSkip: 'Метки для пропуска',
      jiraCommentBlacklist: 'Черный список email комментариев',
      jiraScopedToken: 'Использовать Scoped Token (только Cloud)',
      jiraUserEmail:
        'Email пользователя Jira (Cloud) или Имя пользователя (Server)',
      jiraApiToken: 'API токен Jira (только Cloud)',
      jiraPassword: 'Пароль Jira (только Server)',
      // GitLab field labels
      gitlabProjectOwner: 'Владелец проекта',
      gitlabProjectName: 'Название проекта',
      gitlabAccessToken: 'Персональный токен доступа GitLab',
      gitlabUrl: 'URL GitLab',
      gitlabIncludeMrs: 'Включать Merge Requests',
      gitlabIncludeIssues: 'Включать Issues',
      gitlabIncludeCodeFiles: 'Включать файлы кода',
      // GitHub field labels
      githubRepoOwner: 'Владелец репозитория',
      githubRepoName: 'Название репозитория',
      githubAccessToken: 'Токен доступа GitHub',
      githubIncludePrs: 'Включать Pull Requests',
      githubIncludeIssues: 'Включать Issues',
      // Bitbucket field labels
      bitbucketAccountEmail: 'Email аккаунта Bitbucket',
      bitbucketApiToken: 'API токен Bitbucket',
      bitbucketWorkspace: 'Рабочее пространство',
      bitbucketIndexMode: 'Режим индексации',
      bitbucketModeRepos: 'Репозитории',
      bitbucketModeProjects: 'Проект(ы)',
      bitbucketModeWorkspace: 'Рабочее пространство',
      bitbucketRepoSlugs: 'Слаги репозиториев',
      bitbucketRepoSlugsRequired: 'Требуются слаги репозиториев',
      bitbucketProjectNames: 'Название проекта(ов)',
      bitbucketProjectsRequired: 'Требуются проекты',
      // R2 field labels
      r2AccountId: 'ID аккаунта R2',
      r2AccessKeyId: 'ID ключа доступа R2',
      r2SecretKey: 'Секретный ключ доступа R2',
      r2BucketName: 'Имя бакета',
      // Google Cloud Storage field labels
      gcsAccessKeyId: 'ID ключа доступа GCS',
      gcsSecretKey: 'Секретный ключ доступа GCS',
      gcsBucketName: 'Имя бакета',
      // OCI Storage field labels
      ociNamespace: 'Пространство имен OCI',
      ociRegion: 'Регион OCI',
      ociAccessKeyId: 'ID ключа доступа OCI',
      ociSecretKey: 'Секретный ключ доступа OCI',
      ociBucketName: 'Имя бакета',
      boxDescription:
        'Подключите ваш диск Box для синхронизации файлов и папок.',
      configureModelTitle: 'Настроить модель',
      confluenceDescription:
        'Интегрируйте ваше рабочее пространство Confluence для поиска документации.',
      confluenceIsCloudTip:
        'Отметьте, если это экземпляр Confluence Cloud, снимите для Confluence Server/Data Center',
      confluenceSpaceKeyTip:
        'Необязательно: Укажите ключ пространства для синхронизации только определенного пространства. Оставьте пустым для синхронизации всех доступных пространств. Для нескольких пространств разделите запятыми (например, DEV,DOCS,HR)',
      confluenceWikiBaseUrlTip:
        'Базовый URL вашего экземпляра Confluence (например, https://your-domain.atlassian.net/wiki)',
      connectorNameTip: 'Укажите понятное имя для коннектора',
      confluenceUsername: 'Имя пользователя Confluence',
      confluenceAccessToken: 'Токен доступа Confluence',
      zendeskDomain: 'Домен Zendesk',
      zendeskEmail: 'Email Zendesk',
      zendeskToken: 'Токен Zendesk',
      zendeskContent: 'Содержимое',
      zendeskArticles: 'Статьи',
      zendeskTickets: 'Тикеты',
      asanaApiToken: 'API токен',
      asanaWorkspaceId: 'ID рабочего пространства',
      asanaProjectIds: 'ID проектов',
      asanaTeamId: 'ID команды',
      confluenceWikiBaseUrl: 'Базовый URL Wiki',
      confluenceIsCloud: 'Облачный экземпляр',
      confluenceIndexMode: 'Режим индексации',
      confluenceIndexEverything: 'Все',
      confluenceIndexSpace: 'Пространство',
      confluenceIndexPage: 'Страница',
      confluencePageId: 'ID страницы',
      confluencePageIdRequired: 'Требуется ID страницы',
      confluenceSpaceKey: 'Ключ пространства',
      confluenceSpaceKeyRequired: 'Требуется ключ пространства',
      confluenceIndexRecursively: 'Индексировать рекурсивно',
      confluenceEverythingTip:
        'Этот выбор проиндексирует все страницы, к которым есть доступ у указанных учетных данных.',
      allowImages: 'Разрешить изображения',
      allowImagesTip:
        'Включите для индексации изображений из вложений Confluence.',
      notionIntegrationToken: 'Токен интеграции Notion',
      notionRootPageId: 'ID корневой страницы',
      discordBotToken: 'Токен бота Discord',
      discordServerIds: 'ID серверов',
      discordChannels: 'Каналы',
      dropboxAccessToken: 'Токен доступа',
      dropboxBatchSize: 'Размер пакета',
      boxOAuthJson: 'Box OAuth JSON',
      boxFolderId: 'ID папки',
      // Box token field
      configureBoxCredentials: 'Настроить учетные данные Box',
      getBoxCredentials: 'Получить учетные данные Box',
      boxClientId: 'Client ID',
      boxClientSecret: 'Client Secret',
      boxRedirectUri: 'Redirect URI',
      enterBoxClientId: 'Введите Box Client ID',
      enterBoxClientSecret: 'Введите Box Client Secret',
      boxRedirectUriPlaceholder: 'https://example.com/box/oauth/callback',
      configureBoxOAuth: 'Настроить Box OAuth',
      configureBoxOAuthDescription:
        'Введите Client ID, Client Secret и Redirect URI вашего Box приложения. Эти значения будут сохранены в поле формы и могут использоваться позже для запуска OAuth.',
      boxAuthorizationCompleted: 'Авторизация Box завершена.',
      boxOAuthAuthorized:
        'Учетные данные Box OAuth авторизованы и готовы к использованию.',
      boxOAuthConfigured:
        'Информация о клиенте Box OAuth сохранена. Запустите браузерную авторизацию для завершения настройки.',
      authorized: 'Авторизовано',
      configured: 'Настроено',
      browserAuthorization: 'Браузерная авторизация',
      completeBoxConsent:
        'Завершите согласие Box в открывшемся окне и вернитесь сюда.',
      submitAndAuthorize: 'Отправить и авторизовать',
      // Common OAuth/auth strings
      authorizationConfirmed:
        'Авторизация подтверждена. Финализируем учетные данные...',
      authorizationFailed: 'Ошибка авторизации.',
      unableToRetrieveAuthorization:
        'Не удалось получить результат авторизации.',
      checkingAuthorizationStatus: 'Проверка статуса авторизации...',
      refreshStatus: 'Обновить статус',
      startBrowserAuthFirst: 'Сначала запустите браузерную авторизацию.',
      popupBlocked:
        'Всплывающее окно заблокировано. Разрешите всплывающие окна для этого сайта.',
      failedToStartBoxAuth: 'Не удалось запустить авторизацию Box.',
      fillInClientIdSecretAndUri:
        'Пожалуйста, заполните Client ID, Client Secret и Redirect URI.',
      // Google Drive token field
      uploadGoogleOAuthJson: 'Загрузите ваш Google OAuth JSON файл.',
      completeGoogleVerification: 'Завершите верификацию Google',
      completeGoogleVerificationDescription:
        'Загруженные учетные данные клиента не содержат токен обновления. Запустите поток верификации один раз для создания долгоживущих токенов.',
      authorizeInBrowser: 'Авторизоваться в браузере',
      authorizeInBrowserDescription:
        'Мы откроем страницу согласия Google в новом окне. Войдите с учетной записью администратора, предоставьте доступ и вернитесь сюда. Ваши учетные данные обновятся автоматически.',
      authorizeWithGoogle: 'Авторизоваться через Google',
      googleDriveCredentialsVerified:
        'Учетные данные Google Drive верифицированы.',
      completeGoogleConsent: 'Завершите согласие Google во всплывающем окне.',
      failedToStartBrowserAuth: 'Не удалось запустить браузерную авторизацию.',
      googleDriveTokensWithRefresh:
        'Загружены OAuth токены с токеном обновления.',
      googleDriveClientCredentials:
        'Обнаружены учетные данные клиента. Завершите верификацию для создания долгоживущих токенов.',
      googleDriveStoredCredentials: 'Сохранен JSON с учетными данными Google.',
      verified: 'Верифицировано',
      needsAuthorization: 'Требуется авторизация',
      uploadedPending: 'Загружено (ожидание)',
      invalidJsonFile: 'Неверный JSON файл.',
      oauthCredentialsUploaded: 'Учетные данные OAuth загружены.',
      clientConfigUploaded:
        'Конфигурация клиента загружена. Требуется верификация для завершения настройки.',
      unableToReadUploadedFile: 'Не удалось прочитать загруженный файл.',
      noGoogleCredentialFile: 'Не обнаружен файл учетных данных Google.',
      verificationCanceled:
        'Верификация отменена. Загрузите учетные данные снова для перезапуска.',
      authorizationWindowError: 'Окно авторизации сообщило об ошибке.',
      // Gmail token field
      uploadGmailOAuthJson: 'Загрузите ваш Gmail OAuth JSON файл.',
      completeGmailVerification: 'Завершите верификацию Gmail',
      completeGmailVerificationDescription:
        'Загруженные учетные данные клиента не содержат токен обновления. Запустите поток верификации один раз для создания долгоживущих токенов.',
      gmailCredentialsVerified: 'Учетные данные Gmail верифицированы.',
      gmailOauthCredentialsUploaded: 'Учетные данные Gmail OAuth загружены.',
      gmailTokensWithRefresh: 'Загружены OAuth токены с токеном обновления.',
      gmailClientCredentials:
        'Обнаружены учетные данные клиента. Завершите верификацию для создания долгоживущих токенов.',
      gmailStoredCredentials: 'Сохранен JSON с учетными данными Google.',
      airtableAccessToken: 'Токен доступа',
      airtableBaseId: 'ID базы',
      airtableTableName: 'Имя или ID таблицы',
      source: 'Источник',
      cropImage: 'Обрезать изображение',
      cropTip: 'Тяните рамку, чтобы сдвинуть, угол — чтобы изменить размер',
      datasourceDescription:
        'Управляйте вашими источниками данных и подключениями',
      deleteSourceModalConfirmText: 'Подтвердить',
      deleteSourceModalContent:
        '\n      <p>Вы уверены, что хотите удалить эту ссылку на источник данных?</p>',
      deleteSourceModalTitle: 'Удалить источник данных',
      discordDescription:
        'Свяжите ваш Discord сервер для доступа и анализа данных чата.',
      edit: 'Редактировать',
      errorMsg: 'Сообщение об ошибке',
      githubDescription:
        'Подключите GitHub для синхронизации содержимого Pull Request и Issue для поиска.',
      gitlabDescription:
        'Подключите GitLab для синхронизации репозиториев, задач, merge requests и связанной документации.',
      gmailDescription:
        'Подключите ваш Gmail / Google Workspace аккаунт для синхронизации писем и их метаданных, чтобы построить корпоративную почтовую базу знаний и поиск с учетом прав доступа.',
      gmailPrimaryAdmin: 'Основной административный email',
      gmailOAuthToken: 'OAuth токен JSON',
      gmailPrimaryAdminTip:
        'Основной административный email с доступом к Gmail / Workspace, используется для перечисления пользователей домена и как аккаунт синхронизации по умолчанию.',
      gmailTokenTip:
        'Загрузите OAuth JSON, сгенерированный в Google Console. Если он содержит только учетные данные клиента, выполните одноразовое подтверждение в браузере, чтобы получить долгоживущие токены обновления.',
      google_cloud_storageDescription:
        'Подключите бакет Google Cloud Storage для импорта и синхронизации файлов.',
      google_driveDescription:
        'Подключите ваш Google Drive через OAuth и синхронизируйте определенные папки или диски.',
      googleDrivePrimaryAdmin: 'Основной административный email',
      googleDriveOAuthToken: 'OAuth токен JSON',
      googleDriveMyDriveEmails: 'Email-ы Мой диск',
      googleDriveSharedFolderUrls: 'URL общих папок',
      google_driveMyDriveEmailsTip:
        'Электронные почты через запятую, чье содержимое "Мой диск" должно индексироваться (включите основного администратора).',
      google_drivePrimaryAdminTip:
        'Адрес электронной почты, который имеет доступ к содержимому Диска, которое синхронизируется.',
      google_driveSharedFoldersTip:
        'Ссылки на папки Google Drive через запятую для обхода.',
      google_driveTokenTip:
        'Загрузите JSON токена OAuth, сгенерированный из помощника OAuth или Google Cloud Console. Вы также можете загрузить client_secret JSON из "установленного" или "веб" приложения. Если это ваша первая синхронизация, откроется окно браузера для завершения согласия OAuth. Если JSON уже содержит токен обновления, он будет автоматически повторно использован.',
      imapDescription:
        'Подключите почтовый ящик IMAP для синхронизации писем из указанных почтовых ящиков (mailboxes) с целью поиска и анализа знаний.',
      imapUsername: 'Имя пользователя',
      imapPassword: 'Пароль',
      imapHost: 'Хост',
      imapPort: 'Порт',
      imapMailboxes: 'Почтовые ящики',
      imapPollRange: 'Диапазон опроса',
      jiraAttachmentSizeTip:
        'Вложения размером больше этого количества байт будут пропущены.',
      jiraAttachmentsTip:
        'Загружать вложения как отдельные документы во время синхронизации.',
      jiraBaseUrlTip:
        'Базовый URL вашего сайта Jira (например, https://your-domain.atlassian.net).',
      jiraBatchSizeTip:
        'Максимальное количество задач, запрашиваемых из Jira за пакет.',
      jiraBlacklistTip:
        'Комментарии, автор которых соответствует этим записям, будут игнорироваться.',
      jiraCommentsTip:
        'Включить комментарии Jira в сгенерированный markdown документ.',
      jiraDescription:
        'Подключите ваше рабочее пространство Jira для синхронизации задач, комментариев и вложений.',
      jiraEmailTip: 'Email, связанный с учетной записью/API токеном Jira.',
      jiraJqlTip:
        'Опциональный фильтр JQL. Оставьте пустым, чтобы полагаться на фильтры проекта/времени.',
      jiraLabelsTip:
        'Метки, которые должны быть пропущены при индексации (через запятую).',
      jiraPasswordTip: 'Опциональный пароль для сред Jira Server/Data Center.',
      jiraProjectKeyTip:
        'Опционально: ограничьте синхронизацию одним ключом проекта (например, ENG).',
      jiraScopedTokenTip:
        'Включите это при использовании ограниченных токенов Atlassian (api.atlassian.com).',
      jiraTokenTip:
        'API токен, сгенерированный из https://id.atlassian.com/manage-profile/security/api-tokens.',
      log: 'Лог',
      minimaxBaseUrlPlaceholder:
        '(Только для международных пользователей, введите https://api.minimax.io/v1)',
      minimaxBaseUrlTip:
        'Только для международных пользователей: используйте https://api.minimax.io/v1.',
      newDocs: 'Новые документы',
      notionDescription:
        'Синхронизируйте страницы и базы данных из Notion для извлечения знаний.',
      oci_storageDescription:
        'Подключите бакет Oracle Cloud Object Storage для импорта и синхронизации файлов.',
      paddleocr: {
        apiUrl: 'URL API PaddleOCR',
        apiUrlPlaceholder:
          'Например: https://paddleocr-server.com/layout-parsing',
        accessToken: 'Токен доступа AI Studio',
        accessTokenPlaceholder: 'Ваш токен AI Studio (необязательно)',
        algorithm: 'Алгоритм PaddleOCR',
        selectAlgorithm: 'Выбрать алгоритм',
        modelNamePlaceholder: 'Например: paddleocr-from-env-1',
        modelNameRequired: 'Имя модели является обязательным',
        apiUrlRequired: 'URL API PaddleOCR является обязательным',
      },
      r2Description:
        'Подключите ваш бакет Cloudflare R2 для импорта и синхронизации файлов.',
      s3Description:
        'Подключитесь к вашему AWS S3 бакету для импорта и синхронизации хранимых файлов.',
      s3PrefixTip:
        'Укажите путь к папке в вашем S3 бакете для получения файлов.\nПример: general/v2/',
      s3BucketName: 'Имя бакета',
      s3Region: 'Регион',
      s3Prefix: 'Префикс',
      s3Mode: 'Режим',
      s3ModeS3: 'S3',
      s3ModeCompatible: 'S3 Compatible',
      s3Authentication: 'Аутентификация',
      s3AuthAccessKey: 'Access Key',
      s3AuthIamRole: 'IAM Role',
      s3AuthAssumeRole: 'Assume Role',
      s3AwsAccessKeyId: 'AWS Access Key ID',
      s3AwsAccessKeyIdRequired: 'Требуется AWS Access Key ID',
      s3AwsSecretKey: 'AWS Secret Access Key',
      s3AwsSecretKeyRequired: 'Требуется AWS Secret Access Key',
      s3AwsRoleArn: 'AWS Role ARN',
      s3AwsRoleArnTip: 'Роль будет использована средой выполнения.',
      s3AwsRoleArnRequired: 'Требуется AWS Role ARN',
      s3AssumeRoleTip:
        'Учётные данные не требуются. Используется роль среды выполнения по умолчанию.',
      s3RegionRequired: 'Регион обязателен при использовании access key',
      s3EndpointUrl: 'URL конечной точки',
      s3AddressingStyle: 'Стиль адресации',
      s3AddressingVirtual: 'Virtual Hosted Style',
      s3AddressingPath: 'Path Style',
      save: 'Сохранить',
      search: 'Поиск',
      selectModelPlaceholder: 'Выберите модель',
      systemModelDescription:
        'Пожалуйста, завершите эти настройки перед началом',
      timeStarted: 'Время начала',
      zendeskDescription:
        'Подключите Zendesk для синхронизации тикетов, статей и другого контента.',
      showcase: 'Витрина',
      Verify: 'Проверить',
      keyValid: 'Ваш API ключ действителен.',
      keyInvalid: 'Ваш API ключ недействителен.',
      deleteModel: 'Удалить модель',
      bedrockCredentialsHint:
        'Подсказка: оставьте Access Key / Secret Key пустыми для аутентификации через AWS IAM.',
      awsAuthModeAccessKeySecret: 'Access Key',
      awsAuthModeIamRole: 'IAM Role',
      awsAuthModeAssumeRole: 'Assume Role',
      awsAccessKeyId: 'AWS Access Key ID',
      awsSecretAccessKey: 'AWS Secret Access Key',
      awsRoleArn: 'AWS Role ARN',
      awsRoleArnMessage: 'Введите AWS Role ARN',
      awsAssumeRoleTip:
        'В этом режиме экземпляр Amazon EC2 использует свою существующую роль для доступа к сервисам AWS. Дополнительные учётные данные не требуются.',
      modelEmptyTip:
        'Нет доступных моделей. <br>Добавьте модели на панели справа.',
      sourceEmptyTip:
        'Источники данных ещё не добавлены. Выберите один ниже для подключения.',
      seconds: 'секунд',
      minutes: 'минут',
      webdavDescription:
        'Подключитесь к WebDAV серверам для синхронизации файлов.',
      webdavServerUrl: 'URL сервера WebDAV',
      webdavUsername: 'Имя пользователя',
      webdavPassword: 'Пароль',
      webdavRemotePath: 'Удаленный путь',
      webdavRemotePathTip:
        'Необязательно: укажите путь к папке на WebDAV сервере (например, /Documents). Оставьте пустым для синхронизации с корня.',
      dropboxDescription:
        'Подключите Dropbox для синхронизации файлов и папок из выбранного аккаунта.',
      dropboxAccessTokenTip:
        'Создайте долгоживущий токен доступа в Dropbox App Console с правами files.metadata.read, files.content.read и sharing.read.',
      moodleDescription:
        'Подключитесь к Moodle LMS для синхронизации курсов, форумов и материалов.',
      moodleUrlTip:
        'Базовый URL вашего Moodle (например, https://moodle.university.edu). Не включайте /webservice или /login.',
      moodleTokenTip:
        'Создайте токен веб-сервиса в Moodle: Администрирование → Сервер → Веб-сервисы → Управление токенами. Пользователь должен быть записан на курсы для синхронизации.',
      seafileDescription:
        'Подключитесь к SeaFile серверу для синхронизации файлов и документов из библиотек.',
      seafileServerUrl: 'URL сервера SeaFile',
      seafileApiToken: 'API токен',
      seafileIncludeShared: 'Включить общие библиотеки',
      seafileBatchSize: 'Размер пакета',
      seafileUrlTip:
        'Базовый URL вашего SeaFile сервера (например, https://seafile.example.com). Не включайте /api2 или другие пути.',
      seafileTokenTip:
        'Создайте API токен в SeaFile: Настройки → API Token → Generate Token. Токен даёт доступ ко всем библиотекам вашего аккаунта.',
      seafileIncludeSharedTip:
        'При включении библиотеки, которыми с вами поделились, также будут синхронизированы.',
      seafileBatchSizeTip:
        'Количество документов в пакете. Большие значения могут ускорить обработку, но потребуют больше памяти. По умолчанию: 100.',
      mysqlDescription:
        'Подключитесь к MySQL для синхронизации данных из таблиц с помощью SQL-запросов.',
      mysqlQueryTip:
        'SQL-запрос для извлечения данных из БД (например, SELECT * FROM products WHERE status = "active").',
      mysqlContentColumnsTip:
        'Имена столбцов через запятую, значения которых объединяются в содержимое документа для векторизации.',
      mysqlMetadataColumnsTip:
        'Имена столбцов через запятую для метаданных документа (не векторизуются, но доступны для поиска).',
      mysqlIdColumnTip:
        'Столбец для уникального ID документа. Если не указан, используется хеш содержимого.',
      mysqlTimestampColumnTip:
        'Столбец datetime/timestamp для инкрементальной синхронизации. Загружаются только строки, изменённые после последней синхронизации.',
      postgresqlDescription:
        'Подключитесь к PostgreSQL для синхронизации данных из таблиц с помощью SQL-запросов.',
      postgresqlQueryTip:
        "SQL-запрос для извлечения данных из БД (например, SELECT * FROM products WHERE status = 'active').",
      postgresqlContentColumnsTip:
        'Имена столбцов через запятую, значения которых объединяются в содержимое документа для векторизации.',
      postgresqlMetadataColumnsTip:
        'Имена столбцов через запятую для метаданных документа (не векторизуются, но доступны для поиска).',
      postgresqlIdColumnTip:
        'Столбец для уникального ID документа. Если не указан, используется хеш содержимого.',
      postgresqlTimestampColumnTip:
        'Столбец datetime/timestamp для инкрементальной синхронизации. Загружаются только строки, изменённые после последней синхронизации.',
      mineru: {
        modelNameRequired: 'Требуется имя модели',
        apiServerRequired: 'Требуется конфигурация MinerU API Server',
        serverUrlBackendLimit:
          'URL MinerU Server доступен только для бэкенда HTTP client',
        apiserver: 'Конфигурация MinerU API Server',
        outputDir: 'Путь к выходной директории MinerU',
        backend: 'Тип бэкенда обработки MinerU',
        serverUrl: 'URL адрес MinerU Server',
        deleteOutput: 'Удалять выходные файлы после обработки',
        selectBackend: 'Выбрать бэкенд обработки',
        backendOptions: {
          pipeline: 'Стандартная конвейерная обработка',
          vlmTransformers: 'Vision Language Model с Transformers',
          vlmVllmEngine: 'Vision Language Model с vLLM Engine',
          vlmHttpClient: 'Vision Language Model через HTTP Client',
          vlmMlxEngine: 'Vision Language Model с MLX Engine',
          vlmVllmAsyncEngine:
            'Vision Language Model с vLLM Async Engine (экспериментально)',
          vlmLmdeployEngine:
            'Vision Language Model с LMDeploy Engine (экспериментально)',
        },
      },
      modelTypes: {
        chat: 'Чат',
        embedding: 'Эмбеддинг',
        rerank: 'Реранкинг',
        sequence2text: 'sequence2text',
        tts: 'TTS',
        image2text: 'OCR',
        speech2text: 'ASR',
      },
      showToc: 'Показать оглавление',
      hideToc: 'Скрыть оглавление',
    },
    message: {
      '200': 'Сервер успешно вернул запрошенные данные.',
      '201': 'Данные успешно созданы или изменены.',
      '202': 'Запрос поставлен в очередь (асинхронная задача).',
      '204': 'Данные успешно удалены.',
      '400': 'Ошибка в запросе, сервер не создал/не изменил данные.',
      '401': 'Пожалуйста, войдите снова.',
      '403': 'Пользователь авторизован, но доступ запрещен.',
      '404': 'Запрошенная запись не существует.',
      '406': 'Запрошенный формат недоступен.',
      '410': 'Ресурс удален и больше не доступен.',
      '413': 'Слишком большой общий размер загружаемых файлов.',
      '422': 'Ошибка валидации при создании объекта.',
      '500': 'Ошибка сервера, проверьте сервер.',
      '502': 'Ошибка шлюза.',
      '503': 'Сервис недоступен, перегружен или на обслуживании.',
      '504': 'Таймаут шлюза.',
      registered: 'Зарегистрирован!',
      logout: 'выход',
      logged: 'вошел!',
      pleaseSelectChunk: 'Выберите фрагмент!',
      registerDisabled: 'Регистрация пользователей отключена',
      modified: 'Изменено',
      created: 'Создано',
      deleted: 'Удалено',
      renamed: 'Переименовано',
      operated: 'Выполнено',
      updated: 'Обновлено',
      uploaded: 'Загружено',
      requestError: 'Ошибка',
      networkAnomalyDescription:
        'Проблемы с сетью, невозможно подключиться к серверу.',
      networkAnomaly: 'Сетевая аномалия',
      hint: 'Подсказка',
    },
    fileManager: {
      name: 'Название',
      uploadDate: 'Дата загрузки',
      knowledgeBase: 'База знаний',
      size: 'Размер',
      action: 'Действие',
      addToKnowledge: 'Связать с Базой Знаний',
      pleaseSelect: 'Выберите',
      newFolder: 'Новая папка',
      file: 'Файл',
      uploadFile: 'Загрузить файл',
      parseOnCreation: 'Обработать при создании',
      directory: 'Директория',
      uploadTitle: 'Перетащите файлы для загрузки',
      uploadDescription: 'Поддерживает одиночную или пакетную загрузку.',
      local: 'Локальные загрузки',
      s3: 'S3 загрузки',
      preview: 'Просмотр',
      fileError: 'Ошибка файла',
      uploadLimit: 'Каждый файл ≤10MB, всего файлов ≤128.',
      destinationFolder: 'Целевая папка',
      files: 'Файлы',
      pleaseUploadAtLeastOneFile: 'Пожалуйста, загрузите хотя бы один файл',
    },
    flow: {
      recommended: 'Рекомендуемые',
      agent: 'Агенты',
      customerSupport: 'Поддержка клиентов',
      marketing: 'Маркетинг',
      consumerApp: 'Приложение для потребителей',
      ingestionPipeline: 'Конвейер загрузки',
      pipeline: 'Конвейер загрузки',
      other: 'Другое',
      agents: 'Агенты',
      days: 'Дни',
      beginInput: 'Входные параметры',
      ref: 'Переменная',
      stockCode: 'Код акции',
      apiKeyPlaceholder:
        'ВАШ_API_КЛЮЧ (получите на https://serpapi.com/manage-api-key)',
      flowStart: 'Старт',
      flowNum: 'Номер',
      test: 'Тест',
      extractDepth: 'Глубина извлечения',
      format: 'Формат',
      basic: 'Базовый',
      advanced: 'Продвинутый',
      general: 'Общий',
      searchDepth: 'Глубина поиска',
      tavilyTopic: 'Тема Tavily',
      maxResults: 'Макс. результатов',
      includeAnswer: 'Включить ответ',
      includeRawContent: 'Включить необработанный контент',
      includeImages: 'Включить изображения',
      includeImageDescriptions: 'Включить описания изображений',
      includeDomains: 'Включить домены',
      ExcludeDomains: 'Исключить домены',
      Days: 'Дни',
      comma: 'Запятая',
      semicolon: 'Точка с запятой',
      period: 'Точка',
      lineBreak: 'Перенос строки',
      tab: 'Табуляция',
      space: 'Пробел',
      delimiters: 'Разделители',
      merge: 'Объединить',
      split: 'Разделить',
      script: 'Скрипт',
      iterationItemDescription:
        'Представляет текущий элемент в итерации, который может быть использован и изменен в последующих шагах.',
      guidingQuestion: 'Руководящий вопрос',
      onFailure: 'При ошибке',
      userPromptDefaultValue: 'Это команда, которую нужно отправить агенту.',
      search: 'Поиск',
      communication: 'Коммуникации',
      developer: 'Разработчик',
      typeCommandOrsearch: 'Введите команду или выполните поиск...',
      builtIn: 'Встроенные',
      ExceptionDefaultValue: 'Значение по умолчанию для исключения',
      exceptionMethod: 'Метод обработки исключений',
      maxRounds: 'Макс. раундов рефлексии',
      delayEfterError: 'Задержка после ошибки',
      maxRetries: 'Макс. повторных попыток',
      advancedSettings: 'Расширенные настройки',
      addTools: 'Добавить инструменты',
      sysPromptDefultValue:
        '\n' +
        '      <role>\n' +
        '        Вы полезный ассистент, ИИ-ассистент, специализирующийся на решении проблем для пользователя.\n' +
        '        Если предоставлена конкретная область, адаптируйте свою экспертизу к этой области; в противном случае действуйте как универсалист.\n' +
        '      </role>\n' +
        '      <instructions>\n' +
        '        1. Поймите запрос пользователя.\n' +
        '        2. Разбейте его на логические подзадачи.\n' +
        '        3. Выполняйте каждую подзадачу шаг за шагом, рассуждая прозрачно.\n' +
        '        4. Проверьте точность и согласованность.\n' +
        '        5. Подведите итоги финального результата четко.\n' +
        '      </instructions>',
      singleLineText: 'Однострочный текст',
      multimodalModels: 'Мультимодальные модели',
      textOnlyModels: 'Только текстовые модели',
      allModels: 'Все модели',
      codeExecDescription:
        'Напишите свою пользовательскую логику на Python или Javascript.',
      stringTransformDescription:
        'Изменяет текстовое содержимое. В настоящее время поддерживает: Разделение или объединение текста.',
      foundation: 'Базовые',
      tools: 'Инструменты',
      dataManipulation: 'Обработка данных',
      flow: 'Поток',
      dialog: 'Диалог',
      cite: 'Источник',
      citeTip: 'Источник информации',
      name: 'Название',
      nameMessage: 'Введите название',
      description: 'Описание',
      examples: 'Примеры',
      to: 'Кому',
      msg: 'Сообщения',
      msgTip:
        'Вывод переменной вышестоящего компонента или введенный вами текст.',
      messagePlaceholder:
        "Введите текст сообщения, используйте '/' для вставки переменных.",
      messageMsg: 'Введите сообщение или удалите это поле.',
      addField: 'Добавить поле',
      addMessage: 'Добавить сообщение',
      loop: 'Цикл',
      loopTip:
        'Максимальное количество циклов компонента. При превышении задача не может быть выполнена.',
      yes: 'Да',
      no: 'Нет',
      key: 'Ключ',
      componentId: 'ID компонента',
      add: 'Добавить',
      operation: 'Действие',
      run: 'Запустить',
      save: 'Сохранить',
      title: 'ID:',
      beginDescription: 'Начало потока.',
      answerDescription:
        'Интерфейс между человеком и ботом, принимает ввод пользователя и отображает ответы.',
      retrievalDescription:
        'Извлекает информацию из указанных баз знаний. Убедитесь, что базы используют одну модель эмбеддинга.',
      generateDescription:
        'Генерирует ответы с помощью LLM. Убедитесь, что промпт настроен правильно.',
      categorizeDescription:
        'Классифицирует ввод пользователя в предопределенные категории. Укажите имя, описание и примеры для каждой категории.',
      relevantDescription:
        'Оценивает релевантность вывода вышестоящего компонента последнему запросу пользователя.',
      rewriteQuestionDescription:
        'Переписывает пользовательский запрос на основе контекста предыдущих диалогов.',
      messageDescription:
        'Возвращает итоговый вывод рабочего процесса с предопределенным содержимым.',
      keywordDescription: 'Извлекает топ N результатов из ввода пользователя.',
      switchDescription: 'Оценивает условия и направляет поток выполнения.',
      wikipediaDescription:
        'Ищет на wikipedia.org. Использует TopN для количества результатов.',
      promptText:
        'Обобщите следующие абзацы. Будьте внимательны с числами. Абзацы:\n' +
        '        {input}\n' +
        '  Контент для обобщения.',
      createGraph: 'Создать агента',
      createFromTemplates: 'Создать из шаблонов',
      retrieval: 'Поиск',
      generate: 'Генерация',
      answer: 'Взаимодействие',
      categorize: 'Классификация',
      relevant: 'Релевантность',
      rewriteQuestion: 'Переписать',
      rewrite: 'Переписать',
      begin: 'Начало',
      message: 'Сообщение',
      blank: 'Пустой',
      createFromNothing: 'Создать агента с нуля',
      addItem: 'Добавить элемент',
      addSubItem: 'Добавить подэлемент',
      nameRequiredMsg: 'Требуется название',
      nameRepeatedMsg: 'Название не должно повторяться',
      keywordExtract: 'Ключевые слова',
      keywordExtractDescription:
        'Извлекает ключевые слова из запроса пользователя.',
      baidu: 'Baidu',
      baiduDescription: 'Ищет на baidu.com.',
      duckDuckGo: 'DuckDuckGo',
      duckDuckGoDescription: 'Ищет на duckduckgo.com.',
      searXNG: 'SearXNG',
      searXNGDescription:
        'Компонент, который выполняет поиск по указанному вами URL-адресу экземпляра SearXNG. Укажите TopN и URL-адрес экземпляра.',
      yandexSearch: 'Поиск в Яндексе',
      yandexSearchDescription:
        'Компонент для поиска в Яндексе. Идеально подходит для русскоязычного контента и региона СНГ. Использует Yandex Cloud Search API.',
      presenton: 'Презентация',
      presentonDescription:
        'Создание презентации. Добавьте инструмент Retrieval для данных из баз знаний или подключите подагентов для дополнительного контекста.',
      presentonPrompt: 'Стартовый промпт',
      presentonPromptTip:
        'Обязательно. Presenton всегда стартует с этим промптом. Поддерживаются переменные из предыдущих нод.',
      presentonPromptPlaceholder: 'Введите текст или вставьте переменные',
      presentonImageModel: 'Модель изображений',
      presentonImageModelTip: 'Модель для генерации изображений в презентации.',
      presentonDefaultLanguage: 'Язык по умолчанию',
      presentonDefaultLanguageTip:
        'Начальный язык презентации, который передается в Presenton.',
      presentonDefaultSlideCount: 'Количество слайдов по умолчанию',
      presentonDefaultSlideCountTip:
        'Начальное количество слайдов, которое передается в Presenton.',
      presentonDelivery: 'Что возвращает нода',
      presentonDeliveryTip:
        'План: в чате показывается план, дальше пользователь продолжает в редакторе. Готовый файл: презентация целиком генерируется по выбранному шаблону и прикладывается к ответу, без участия пользователя.',
      presentonDeliveryPlan: 'План в чате, затем редактор',
      presentonDeliveryFile: 'Готовый файл в чате',
      presentonExportFormat: 'Формат файла',
      presentonExportFormatTip: 'Формат файла, который приложен к ответу.',
      presentonTemplatesSection: 'Шаблоны',
      presentonTemplate: 'Шаблон по умолчанию',
      presentonTemplateTip:
        'Шаблон по умолчанию для этой ноды (автостарт / неинтерактивная генерация). В чате пользователь по-прежнему может выбрать другой шаблон.',
      presentonTemplateVisionModel: 'Vision-модель редактора',
      presentonTemplateVisionModelTip:
        'Только для создания и правки своих шаблонов в визуальном редакторе (image-in). Не используется для генерации слайдов в чате.',
      presentonTemplateVisionModelRequired:
        'Сначала выберите vision-модель редактора выше, затем создайте или отредактируйте шаблон.',
      presentonTemplateManage: 'Управление шаблонами',
      presentonTemplatesCustomGroup: 'Мои шаблоны',
      presentonTemplatesBundledGroup: 'Встроенные',
      presentonTemplateManager: 'Управление шаблонами',
      presentonTemplateCreate: 'Создать шаблон',
      presentonTemplateEdit: 'Редактировать шаблон',
      presentonTemplateDelete: 'Удалить',
      presentonTemplateCustom: 'Свой',
      presentonTemplateBuiltIn: 'Встроенный',
      presentonTemplateDefault: 'По умолчанию',
      presentonTemplateSelected: 'Выбран по умолчанию',
      presentonTemplateLoading: 'Загрузка шаблонов…',
      presentonTemplateLoadFailed: 'Не удалось загрузить шаблоны',
      presentonTemplateRetry: 'Повторить',
      presentonTemplateEmpty: 'Шаблонов пока нет',
      presentonTemplateBackToAgent: 'Назад к агенту',
      presentonTemplateEditor: 'Редактор шаблона',
      presentonTemplateSaved: 'Шаблон сохранён',
      presentonTemplateDeleted: 'Шаблон удалён',
      presentonTemplateDeleteFailed: 'Не удалось удалить шаблон',
      presentonTemplateDeleteConfirm:
        'Удалить этот шаблон? Действие нельзя отменить.',
      presentonTemplateSessionError: 'Не удалось создать сессию Presenton',
      yandexFolderId: 'Folder ID',
      yandexFolderIdTip: 'Идентификатор каталога в Yandex Cloud',
      yandexFolderIdPlaceholder: 'Введите Folder ID из Yandex Cloud',
      yandexSearchType: 'Тип поиска',
      yandexSearchTypeTip: 'Выберите тип поиска по региону',
      yandexSearchTypeRU: 'Русский',
      yandexSearchTypeTR: 'Турецкий',
      yandexSearchTypeCOM: 'Международный',
      yandexSearchTypeKK: 'Казахский',
      yandexSearchTypeBE: 'Белорусский',
      yandexSearchTypeUZ: 'Узбекский',
      yandexApiKeyPlaceholder: 'Введите API-ключ из Yandex Cloud',
      yandexTrackerCreate: 'Яндекс Трекер: Создать задачу',
      yandexTrackerCreateDescription:
        'Создание задач в Яндекс Трекере. Агент может создавать баги, задачи и истории в указанной очереди.',
      yandexTrackerRead: 'Яндекс Трекер: Прочитать задачу',
      yandexTrackerReadDescription:
        'Чтение задачи из Яндекс Трекера по ключу или ссылке. Возвращает описание, статус, исполнителя и комментарии.',
      yandexTrackerOauthToken: 'OAuth-токен',
      yandexTrackerOrgId: 'ID организации',
      yandexTrackerOrgIdTip:
        'ID организации Яндекс 360. Найти можно в админке admin.yandex.ru.',
      yandexTrackerDefaultQueue: 'Очередь по умолчанию',
      yandexTrackerDefaultQueueTip:
        'Ключ очереди, если агент не указал явно, например PROJ.',
      productivity: 'Продуктивность',
      channel: 'Канал',
      channelTip: 'Текстовый или новостной поиск',
      text: 'Текст',
      news: 'Новости',
      messageHistoryWindowSize: 'Размер окна истории',
      messageHistoryWindowSizeTip:
        'Количество сообщений истории, видимых LLM. Учитывайте ограничение токенов модели.',
      wikipedia: 'Wikipedia',
      pubMed: 'PubMed',
      pubMedDescription: 'Ищет на https://pubmed.ncbi.nlm.nih.gov/.',
      email: 'Email',
      emailTip: 'Email обязателен.',
      arXiv: 'ArXiv',
      arXivDescription: 'Ищет на https://arxiv.org/.',
      sortBy: 'Сортировать по',
      submittedDate: 'Дата отправки',
      lastUpdatedDate: 'Дата обновления',
      relevance: 'Релевантность',
      google: 'Google',
      googleDescription:
        'Ищет на https://www.google.com/. Требуется API ключ от serpapi.com.',
      bing: 'Bing',
      bingDescription:
        'Ищет на https://www.bing.com/. Требуется API ключ от microsoft.com.',
      apiKey: 'API КЛЮЧ',
      country: 'Страна и регион',
      language: 'Язык',
      googleScholar: 'Google Scholar',
      googleScholarDescription: 'Ищет на https://scholar.google.com/.',
      yearLow: 'Год от',
      yearHigh: 'Год до',
      patents: 'Патенты',
      data: 'Данные',
      deepL: 'DeepL',
      deepLDescription: 'Перевод с помощью https://www.deepl.com/.',
      authKey: 'Ключ авторизации',
      sourceLang: 'Исходный язык',
      targetLang: 'Целевой язык',
      gitHub: 'GitHub',
      gitHubDescription: 'Ищет репозитории на https://github.com/.',
      baiduFanyi: 'BaiduFanyi',
      baiduFanyiDescription: 'Перевод с помощью https://fanyi.baidu.com/.',
      appid: 'App ID',
      secretKey: 'Секретный ключ',
      domain: 'Домен',
      transType: 'Тип перевода',
      baiduSecretKeyOptions: {
        translate: 'Общий перевод',
        fieldtranslate: 'Специализированный перевод',
      },
      baiduDomainOptions: {
        it: 'Информационные технологии',
        finance: 'Финансы и экономика',
        machinery: 'Машиностроение',
        senimed: 'Биомедицина',
        novel: 'Онлайн литература',
        academic: 'Академические статьи',
        aerospace: 'Аэрокосмическая',
        wiki: 'Гуманитарные науки',
        news: 'Новости',
        law: 'Законы',
        contract: 'Контракты',
      },
      baiduSourceLangOptions: {
        auto: 'Автоопределение',
        zh: 'Китайский',
        en: 'Английский',
        yue: 'Кантонский',
        wyw: 'Классический китайский',
        jp: 'Японский',
        kor: 'Корейский',
        fra: 'Французский',
        spa: 'Испанский',
        th: 'Тайский',
        ara: 'Арабский',
        ru: 'Русский',
        pt: 'Португальский',
        de: 'Немецкий',
        it: 'Итальянский',
        el: 'Греческий',
        nl: 'Голландский',
        pl: 'Польский',
        bul: 'Болгарский',
        est: 'Эстонский',
        dan: 'Датский',
        fin: 'Финский',
        cs: 'Чешский',
        rom: 'Румынский',
        slo: 'Словенский',
        swe: 'Шведский',
        hu: 'Венгерский',
        cht: 'Традиционный китайский',
        vie: 'Вьетнамский',
      },
      qWeather: 'QWeather',
      qWeatherDescription:
        'Получает погодную информацию с https://www.qweather.com/.',
      lang: 'Язык',
      type: 'Тип',
      webApiKey: 'Web API ключ',
      userType: 'Тип пользователя',
      timePeriod: 'Период времени',
      qWeatherLangOptions: {
        zh: 'Упрощенный китайский',
        'zh-hant': 'Традиционный китайский',
        en: 'Английский',
        de: 'Немецкий',
        es: 'Испанский',
        fr: 'Французский',
        it: 'Итальянский',
        ja: 'Японский',
        ko: 'Корейский',
        ru: 'Русский',
        hi: 'Хинди',
        th: 'Тайский',
        ar: 'Арабский',
        pt: 'Португальский',
        bn: 'Бенгальский',
        ms: 'Малайский',
        nl: 'Голландский',
        el: 'Греческий',
        la: 'Латинский',
        sv: 'Шведский',
        id: 'Индонезийский',
        pl: 'Польский',
        tr: 'Турецкий',
        cs: 'Чешский',
        et: 'Эстонский',
        vi: 'Вьетнамский',
        fil: 'Филиппинский',
        fi: 'Финский',
        he: 'Иврит',
        is: 'Исландский',
        nb: 'Норвежский',
      },
      qWeatherTypeOptions: {
        weather: 'Прогноз погоды',
        indices: 'Индекс погоды',
        airquality: 'Качество воздуха',
      },
      qWeatherUserTypeOptions: {
        free: 'Бесплатный',
        paid: 'Платный',
      },
      qWeatherTimePeriodOptions: {
        now: 'Сейчас',
        '3d': '3 дня',
        '7d': '7 дней',
        '10d': '10 дней',
        '15d': '15 дней',
        '30d': '30 дней',
      },
      publish: 'API',
      exeSQL: 'Выполнить SQL',
      exeSQLDescription:
        'Выполняет SQL-запросы к реляционным БД (MySQL, PostgreSQL, MariaDB).',
      dbType: 'Тип БД',
      database: 'База данных',
      username: 'Имя пользователя',
      host: 'Хост',
      port: 'Порт',
      password: 'Пароль',
      switch: 'Переключатель',
      logicalOperator: 'Логический оператор',
      switchOperatorOptions: {
        equal: 'Равно',
        notEqual: 'Не равно',
        gt: 'Больше',
        ge: 'Больше или равно',
        lt: 'Меньше',
        le: 'Меньше или равно',
        contains: 'Содержит',
        notContains: 'Не содержит',
        startWith: 'Начинается с',
        endWith: 'Заканчивается на',
        empty: 'Пусто',
        notEmpty: 'Не пусто',
        in: 'Входит',
        notIn: 'Не входит',
        is: 'Равно',
        isNot: 'Не равно',
      },
      switchLogicOperatorOptions: {
        and: 'И',
        or: 'ИЛИ',
      },
      operator: 'Оператор',
      value: 'Значение',
      useTemplate: 'Использовать',
      wenCai: 'WenCai',
      queryType: 'Тип запроса',
      wenCaiDescription:
        'Получает финансовую информацию, включая цены акций и новости.',
      wenCaiQueryTypeOptions: {
        stock: 'Акции',
        zhishu: 'Индекс',
        fund: 'Фонды',
        hkstock: 'Гонконгские акции',
        usstock: 'Американские акции',
        threeboard: 'Новый внебиржевой рынок',
        conbond: 'Конвертируемые облигации',
        insurance: 'Страхование',
        futures: 'Фьючерсы',
        lccp: 'Финансирование',
        foreign_exchange: 'Иностранная валюта',
      },
      akShare: 'AkShare',
      akShareDescription:
        'Получает новости об акциях с https://www.eastmoney.com/.',
      yahooFinance: 'YahooFinance',
      yahooFinanceDescription:
        'Запрашивает информацию о публичной компании по тикеру.',
      crawler: 'Веб-краулер',
      crawlerDescription: 'Скачивает HTML-код с указанного URL.',
      proxy: 'Прокси',
      crawlerResultOptions: {
        html: 'Html',
        markdown: 'Markdown',
        content: 'Содержимое',
      },
      extractType: 'Тип извлечения',
      info: 'Информация',
      history: 'История',
      financials: 'Финансы',
      balanceSheet: 'Баланс',
      cashFlowStatement: 'Отчет о движении денежных средств',
      jin10: 'Jin10',
      jin10Description: 'Получает финансовую информацию с Jin10 Open Platform.',
      flashType: 'Тип новости',
      filter: 'Фильтр',
      contain: 'Содержит',
      calendarType: 'Тип календаря',
      calendarDatashape: 'Форма данных календаря',
      symbolsDatatype: 'Тип данных символов',
      symbolsType: 'Тип символов',
      jin10TypeOptions: {
        flash: 'Экспресс-новости',
        calendar: 'Календарь',
        symbols: 'Котировки',
        news: 'Справка',
      },
      jin10FlashTypeOptions: {
        '1': 'Рыночные новости',
        '2': 'Новости фьючерсов',
        '3': 'Новости США-Гонконг',
        '4': 'Новости акций',
        '5': 'Новости товаров и форекс',
      },
      jin10CalendarTypeOptions: {
        cj: 'Календарь макроэкономических данных',
        qh: 'Календарь фьючерсов',
        hk: 'Календарь гонконгского рынка',
        us: 'Календарь американского рынка',
      },
      jin10CalendarDatashapeOptions: {
        data: 'Данные',
        event: 'События',
        holiday: 'Праздники',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'Котировки товаров',
        FOREX: 'Котировки форекс',
        FUTURE: 'Международные котировки',
        CRYPTO: 'Криптовалюты',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'Список товаров',
        quotes: 'Последние котировки',
      },
      concentrator: 'Концентратор',
      concentratorDescription:
        'Принимает вывод вышестоящего компонента и передает его нижестоящим.',
      tuShare: 'TuShare',
      tuShareDescription:
        'Получает финансовые новости с основных финансовых сайтов.',
      tuShareSrcOptions: {
        sina: 'Sina',
        wallstreetcn: 'wallstreetcn',
        '10jqka': 'Стрит-флеш',
        eastmoney: 'Eastmoney',
        yuncaijing: 'YUNCAIJING',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'JRJ',
      },
      token: 'Токен',
      src: 'Источник',
      startDate: 'Дата начала',
      endDate: 'Дата окончания',
      keyword: 'Ключевое слово',
      note: 'Примечание',
      noteDescription: 'Примечание',
      notePlaceholder: 'Введите примечание',
      invoke: 'HTTP Запрос',
      invokeDescription:
        'Вызывает удаленные сервисы, используя вывод других компонентов или константы как входные данные.',
      url: 'Url',
      method: 'Метод',
      timeout: 'Таймаут',
      headers: 'Заголовки',
      cleanHtml: 'Очистить HTML',
      cleanHtmlTip:
        'Включите, если нужен только основной контент из HTML-ответа.',
      reference: 'Ссылка',
      input: 'Вход',
      output: 'Выход',
      parameter: 'Параметр',
      howUseId: 'Как использовать ID агента?',
      content: 'Содержимое',
      operationResults: 'Результаты операций',
      autosaved: 'Автосохранено',
      optional: 'Опционально',
      pasteFileLink: 'Вставить ссылку на файл',
      testRun: 'Тестовый запуск',
      template: 'Шаблон',
      templateDescription:
        'Форматирует вывод других компонентов. Поддерживает Jinja2 и замену строк {параметр}.',
      emailComponent: 'Email',
      emailDescription: 'Отправляет email на указанный адрес.',
      smtpServer: 'SMTP Сервер',
      smtpPort: 'SMTP Порт',
      senderEmail: 'Email отправителя',
      authCode: 'Код авторизации',
      senderName: 'Имя отправителя',
      toEmail: 'Email получателя',
      ccEmail: 'Копия (CC)',
      emailSubject: 'Тема',
      emailContent: 'Содержимое',
      smtpServerRequired: 'Введите адрес SMTP сервера',
      senderEmailRequired: 'Введите email отправителя',
      authCodeRequired: 'Введите код авторизации',
      toEmailRequired: 'Введите email получателя',
      emailContentRequired: 'Введите содержимое письма',
      emailSentSuccess: 'Email успешно отправлен',
      emailSentFailed: 'Ошибка отправки email',
      dynamicParameters: 'Динамические параметры',
      jsonFormatTip:
        'Вышестоящий компонент должен предоставить JSON-строку в формате:',
      toEmailTip: 'to_email: Email получателя (Обязательно)',
      ccEmailTip: 'cc_email: Копия (CC) (Опционально)',
      subjectTip: 'subject: Тема письма (Опционально)',
      contentTip: 'content: Содержимое письма (Опционально)',
      jsonUploadTypeErrorMessage: 'Загрузите json файл',
      jsonUploadContentErrorMessage: 'Ошибка json файла',
      iteration: 'Итерация',
      iterationDescription:
        'Циклический компонент, выполняющий логику для каждого элемента входного массива.',
      delimiterTip:
        '\nРазделитель используется для разбиения входного текста на части для каждой итерации.',
      delimiterOptions: {
        comma: 'Запятая',
        lineBreak: 'Перенос строки',
        linebreak: 'Разрыв строки',
        tab: 'Табуляция',
        underline: 'Подчеркивание',
        diagonal: 'Косая черта',
        minus: 'Дефис',
        semicolon: 'Точка с запятой',
      },
      addVariable: 'Добавить переменную',
      variableSettings: 'Настройки переменных',
      globalVariables: 'Глобальные переменные',
      systemPrompt: 'Системный промпт',
      addCategory: 'Добавить категорию',
      categoryName: 'Название категории',
      nextStep: 'Следующий шаг',
      variableExtractDescription:
        'Извлекает информацию пользователя в глобальную переменную в течение диалога',
      variableExtract: 'Переменные',
      variables: 'Переменные',
      variablesTip:
        'Задайте четкие json-ключи с пустыми значениями. Например:\n' +
        '      {\n' +
        '        "UserCode":"",\n' +
        '        "NumberPhone":""\n' +
        '      }',
      datatype: 'MINE тип HTTP запроса',
      insertVariableTip: 'Введите / Вставьте переменные',
      historyversion: 'История версий',
      filename: 'Имя файла',
      version: {
        created: 'Создано',
        details: 'Детали версии',
        dsl: 'DSL',
        download: 'Скачать',
        version: 'Версия',
        select: 'Версия не выбрана',
      },
      setting: 'Настройки',
      settings: {
        agentSetting: 'Настройки агента',
        title: 'название',
        description: 'описание',
        upload: 'Загрузить',
        photo: 'Фото',
        permissions: 'Права доступа',
        permissionsTip: 'Установите права для участников команды.',
        piiGuard: 'Маскировать персональные данные',
        piiGuardTip:
          'Заменять обнаруженные персональные данные (телефоны, email, имена и т. п.) на плейсхолдеры перед отправкой запроса во внешнюю языковую модель и восстанавливать их в ответе. Действует совместно с серверной настройкой защиты.',
        piiGuardUnavailableTip:
          'Маскирование недоступно: сервис защиты персональных данных не настроен на сервере. Как только администратор его настроит, переключатель станет доступен.',
        me: 'Только я',
        team: 'Команда',
        onlyOwner: 'Только владелец',
        teamReadonly: 'Команда (только чтение)',
      },
      noMoreData: 'Нет больше данных',
      searchAgentPlaceholder: 'Поиск агента',
      prompt: 'Промпт',
      promptTip:
        'Опишите задачу для LLM, укажите формат ответа и требования. Используйте / для вставки переменных.',
      promptMessage: 'Требуется промпт',
      infor: 'Информационный запуск',
      knowledgeBasesTip:
        'Выберите базы знаний для ассистента или переменные с ID баз знаний.',
      knowledgeBaseVars: 'Переменные базы знаний',
      code: 'Код',
      codeDescription:
        'Позволяет разработчикам писать пользовательскую логику на Python.',
      inputVariables: 'Входные переменные',
      runningHintText: 'выполняется...🕞',
      genericError:
        'Произошла ошибка при обработке запроса. Попробуйте ещё раз.',
      errorProviderRejected:
        'Модель отклонила запрос — возможно, она не поддерживает этот режим. Попробуйте другую модель в настройках ноды.',
      errorPresentonAuth:
        'Не удалось войти в сервис презентаций. Проверьте его настройки.',
      errorPresentationTimeout:
        'Презентация собиралась слишком долго, и сборка прервана. Попробуйте меньше слайдов.',
      errorTimeout:
        'Модель не ответила за отведённое время. Попробуйте ещё раз.',
      errorQuotaExhausted:
        'Квота провайдера исчерпана — ожидание не поможет. Пополните её или смените модель.',
      errorRateLimited:
        'Провайдер ограничил частоту запросов. Повторите через минуту.',
      openingSwitch: 'Приветствие',
      openingCopy: 'Приветственное сообщение',
      openingSwitchTip: 'Пользователи увидят это приветствие в начале.',
      modeTip: 'Режим определяет, как запускается рабочий процесс.',
      beginInputTip:
        'Определите входные параметры для доступа в последующих процессах.',
      query: 'Переменные запроса',
      agentDescription:
        'Создает агентов с рассуждениями, использованием инструментов и многопользовательским взаимодействием.',
      maxRecords: 'Макс. записей',
      createAgent: 'Создать Агента',
      createPipeline: 'Создать конвейер',
      stringTransform: 'Обработка текста',
      userFillUp: 'Ожидание ответа',
      userFillUpDescription:
        'Приостанавливает рабочий процесс и ожидает сообщения пользователя.',
      codeExec: 'Код',
      tavilySearch: 'Tavily Search',
      tavilySearchDescription: 'Поиск через сервис Tavily.',
      tavilyExtract: 'Tavily Extract',
      tavilyExtractDescription: 'Извлечение через Tavily',
      log: 'Журнал',
      management: 'Управление',
      import: 'Импорт',
      export: 'Экспорт',
      seconds: 'Секунды',
      subject: 'Тема',
      tag: 'Тег',
      tagPlaceholder: 'Введите тег',
      descriptionPlaceholder: 'Введите описание',
      line: 'Однострочный текст',
      paragraph: 'Текст абзаца',
      options: 'Выпадающие опции',
      file: 'Загрузка файла',
      integer: 'Число',
      boolean: 'Булево',
      logTimeline: {
        begin: 'Готов к началу',
        agent: 'Агент думает',
        userFillUp: 'Ожидает вас',
        retrieval: 'Ищет знания',
        message: 'Агент говорит',
        awaitResponse: 'Ожидает вас',
        switch: 'Выбирает путь',
        iteration: 'Пакетная обработка',
        categorize: 'Классификация информации',
        code: 'Запускает скрипт',
        textProcessing: 'Организует текст',
        tavilySearch: 'Ищет в интернете',
        tavilyExtract: 'Читает страницу',
        exeSQL: 'Запрос к БД',
        google: 'Поиск в Google',
        wikipedia: 'Поиск в Wikipedia',
        googleScholar: 'Академический поиск',
        gitHub: 'Поиск в GitHub',
        email: 'Отправка email',
        httpRequest: 'Вызов API',
        wenCai: 'Запрос финансовых данных',
        yandexTrackerCreate: 'Создание задачи в трекере',
        yandexTrackerRead: 'Чтение задачи из трекера',
      },
      goto: 'Ветка неудачи',
      comment: 'Значение по умолчанию',
      sqlStatement: 'SQL Выражение',
      sqlStatementTip:
        'Напишите ваш SQL-запрос здесь. Вы можете использовать переменные, чистый SQL или комбинировать их с синтаксисом переменных.',
      frameworkPrompts: 'Фреймворк',
      addAgent: 'Добавить агента',
      conversational: 'диалоговый',
      descriptionMessage: 'Это агент для конкретной задачи.',
      mode: 'Режим',
      queryTip: 'Выберите переменную, которую хотите использовать',
      task: 'задача',
      userPrompt: 'Пользовательский промпт',
      ListOperationsOptions: {
        topN: 'Top N',
        head: 'Первые',
        tail: 'Последние',
        sort: 'Сортировка',
        filter: 'Фильтр',
        dropDuplicates: 'Удалить дубликаты',
      },
      SortMethodOptions: {
        asc: 'По возрастанию',
        desc: 'По убыванию',
      },
      addParser: 'Добавить парсер',
      cancel: 'Отмена',
      chooseAgentType: 'Выберите тип агента',
      createFromBlank: 'Создать с нуля',
      createFromTemplate: 'Создать из шаблона',
      exportJson: 'Экспорт JSON',
      extractor: 'Преобразователь',
      extractorDescription:
        'Используйте LLM для извлечения структурированных инсайтов из фрагментов — например, для суммаризации или классификации.',
      fieldName: 'Куда сохранить результат',
      fields: 'Поле',
      fileFormatOptions: {
        pdf: 'PDF',
        spreadsheet: 'Таблица',
        image: 'Изображение',
        email: 'Email',
        'text&markdown': 'Текст и разметка',
        word: 'Word',
        slides: 'PPTX',
        audio: 'Аудио',
        video: 'Видео',
      },
      fileFormats: 'Тип файла',
      filenameEmbdWeight: 'Вес эмбеддинга имени файла',
      filenameEmbeddingWeight: 'Вес встраивания имени файла',
      hierarchicalMerger: 'Заголовок',
      hierarchicalMergerDescription:
        'Разбивает документы на разделы по иерархии заголовков с возможностью тонкой настройки через regex.',
      hierarchy: 'Иерархия',
      imageParseMethodOptions: {
        ocr: 'OCR',
      },
      importJsonFile: 'Импортировать JSON-файл',
      invalidUrl:
        'Должен быть корректный URL или URL с плейсхолдерами в формате {variable_name} или {component@variable}',
      keywords: 'Ключевые слова',
      linebreak: 'Разрыв строки',
      tokenizerFieldsOptions: {
        text: 'Обработанный текст',
        keywords: 'Ключевые слова',
        questions: 'Вопросы',
        summary: 'Дополненный контекст',
      },
      variableAssignerLogicalOperatorOptions: {
        overwrite: 'Перезаписать',
        clear: 'Очистить',
        set: 'Установить',
        add: 'Добавить',
        subtract: 'Вычесть',
        multiply: 'Умножить',
        divide: 'Разделить',
        append: 'Добавить в конец',
        extend: 'Расширить',
        removeFirst: 'Удалить первый',
        removeLast: 'Удалить последний',
        '*=': 'Умножить',
        '+=': 'Добавить',
        '-=': 'Вычесть',
        '/=': 'Разделить',
      },
      markdownImageResponseType: 'Тип ответа с изображениями в Markdown',
      metadata: 'Метаданные',
      operations: 'Операции',
      operationsOptions: {
        selectKeys: 'Выбрать ключи',
        literalEval: 'Буквальная оценка',
        combine: 'Объединить',
        filterValues: 'Фильтровать значения',
        appendOrUpdate: 'Добавить или обновить',
        removeKeys: 'Удалить ключи',
        renameKeys: 'Переименовать ключи',
      },
      outputFormat: 'Формат вывода',
      overlappedPercent: 'Процент перекрытия (%)',
      parser: 'Парсер',
      parserDescription:
        'Извлекает сырой текст и структуру из файлов для последующей обработки.',
      parserMethod: 'Парсер PDF',
      prompts: {
        system: {
          keywords:
            'Роль\n' +
            'Вы — текстовый аналитик.\n' +
            '\n' +
            'Задача\n' +
            'Извлеките 5 самых важных ключевых слов/фраз из текста.\n' +
            '\n' +
            'Требования\n' +
            '- Суммируйте содержимое и выдайте топ-5 ключевых слов/фраз.\n' +
            '- Ключевые слова ДОЛЖНЫ быть на том же языке, что и исходный текст.\n' +
            '- Ключевые слова разделяются английской запятой.\n' +
            '- Выведите ТОЛЬКО ключевые слова.',
          questions:
            'Роль\n' +
            'Вы — текстовый аналитик.\n' +
            '\n' +
            'Задача\n' +
            'Предложите 3 вопроса по заданному тексту.\n' +
            '\n' +
            'Требования\n' +
            '- Поймите и суммируйте текст, предложите 3 разных вопроса.\n' +
            '- Вопросы НЕ должны повторять смысл.\n' +
            '- Вопросы должны максимально охватывать основное содержание.\n' +
            '- Вопросы ДОЛЖНЫ быть на языке исходного текста.\n' +
            '- Один вопрос в строке.\n' +
            '- Выведите ТОЛЬКО вопросы.',
          summary:
            'Будьте точным суммаризатором. Создайте краткое и достоверное резюме предоставленного текста.\n' +
            '\n' +
            'Ключевые инструкции:\n' +
            '1. Точность: строго опирайтесь на исходный текст, не добавляйте новых фактов.\n' +
            '2. Язык: используйте язык исходного текста.\n' +
            '3. Объективность: передавайте ключевые пункты без предвзятости.\n' +
            '4. Краткость: фокус на главных идеях, без лишних деталей.',
          metadata:
            'Извлеките важную структурированную информацию из текста. Выведите ТОЛЬКО корректную JSON-строку. Если ничего важного нет — {}.\n' +
            '\n' +
            'Важная информация может включать: имена, даты, места, события, ключевые факты, числа и т.п.',
          toc: '',
        },
        user: {
          keywords: 'Текст:\n[Вставьте текст здесь]',
          questions: 'Текст:\n[Вставьте текст здесь]',
          summary: 'Текст для суммаризации:\n[Вставьте текст здесь]',
          metadata: 'Контент: [ВСТАВЬТЕ ТЕКСТ ЗДЕСЬ]',
          toc: '[Вставьте текст здесь]',
        },
      },
      questions: 'Вопросы',
      regularExpressions: 'Регулярные выражения',
      release: 'Опубликовать',
      running: 'Выполняется',
      searchMethod: 'Метод поиска',
      searchMethodTip:
        'Определяет, как можно искать контент — полнотекстово, по эмбеддингам или оба сразу. Индексатор сохранит данные в нужных структурах.',
      sortMethod: 'Метод сортировки',
      splitter: 'Токен',
      splitterDescription:
        'Разделяет текст на фрагменты по длине в токенах с опциональными разделителями и перекрытием.',
      structuredOutput: {
        configuration: 'Конфигурация',
        structuredOutput: 'Структурированный вывод',
      },
      summary: 'Сводка',
      swicthPromptMessage:
        'Промпт изменится. Подтвердите отказ от текущего промпта?',
      switchPromptMessage:
        'Промпт изменится. Подтвердите отказ от текущего промпта?',
      systemPromptPlaceholder:
        'Введите системный промпт для анализа изображений; если пусто, используется значение по умолчанию',
      tableResultType: 'Тип результата таблицы',
      tokenizer: 'Индексатор',
      tokenizerDescription:
        'Преобразует текст в нужную структуру (например, векторные эмбеддинги) в зависимости от выбранного метода поиска.',
      tokenizerRequired: 'Сначала добавьте узел индексатора',
      tokenizerSearchMethodOptions: {
        full_text: 'Полнотекстовый',
        embedding: 'Эмбеддинг',
      },
      viewResult: 'Посмотреть результат',
      addPageNumbers: 'Добавить номера страниц',
      addTimestamp: 'Добавить временную метку',
      ceateAgent: 'Поток агента',
      conversationVariable: 'Переменная диалога',
      dataOperations: 'Операции с данными',
      dataOperationsDescription:
        'Выполнять различные операции над объектом Data.',
      defaultValue: 'Значение по умолчанию',
      delayAfterError: 'Задержка после ошибки',
      downloadFileType: 'Тип скачиваемого файла',
      downloadFileTypeTip: 'Тип файла для скачивания',
      fontFamily: 'Семейство шрифтов',
      fontSize: 'Размер шрифта',
      footer: {
        profile: 'Все права защищены @ React',
      },
      formatTypeError: 'Ошибка формата или типа',
      historyVersion: 'История версий',
      layout: {
        file: 'файл',
        knowledge: 'знания',
        chat: 'чат',
      },
      listOperations: 'Операции со списками',
      listOperationsDescription: 'Выполнять операции над списком.',
      logoHeight: 'Высота логотипа',
      logoImage: 'Изображение логотипа',
      logoPosition: 'Позиция логотипа',
      logoWidth: 'Ширина логотипа',
      marginBottom: 'Нижний отступ',
      marginTop: 'Верхний отступ',
      orientation: 'Ориентация',
      outputDirectory: 'Выходной каталог',
      pDFGenerator: 'Генератор документов',
      pDFGeneratorDescription:
        'Компонент, который генерирует документы (PDF, DOCX, TXT) из содержимого в формате markdown с настраиваемым стилем, изображениями и таблицами. Поддерживает: **жирный**, *курсив*, # заголовки, - списки, таблицы с синтаксисом |.',
      pageSize: 'Размер страницы',
      pdfGenerator: 'Генератор документов',
      pdfGeneratorDescription:
        'Компонент, который генерирует документы (PDF, DOCX, TXT) из содержимого в формате markdown с настраиваемым стилем, изображениями и таблицами. Поддерживает: **жирный**, *курсив*, # заголовки, - списки, таблицы с синтаксисом |.',
      queryRequired: 'Запрос обязателен',
      subtitle: 'Подзаголовок',
      sysPromptDefaultValue:
        '\n' +
        '      <role>\n' +
        '        Вы - полезный ассистент, ИИ-ассистент, специализирующийся на решении проблем для пользователя.\n' +
        '        Если предоставлена конкретная область, адаптируйте вашу экспертизу к этой области; в противном случае действуйте как универсал.\n' +
        '      </role>\n' +
        '      <instructions>\n' +
        '        1. Поймите запрос пользователя.\n' +
        '        2. Разбейте его на логические подзадачи.\n' +
        '        3. Выполните каждую подзадачу шаг за шагом, рассуждая прозрачно.\n' +
        '        4. Проверьте точность и согласованность.\n' +
        '        5. Четко обобщите окончательный результат.\n' +
        '      </instructions>',
      titleFontSize: 'Размер шрифта заголовка',
      typeCommandORsearch: 'Введите команду или поиск...',
      variableAggregator: 'Агрегатор переменных',
      variableAggregatorDescription:
        'Этот процесс агрегирует переменные из нескольких ветвей в одну переменную для достижения единой конфигурации для нижестоящих узлов.\n' +
        '\n' +
        'Узел агрегации переменных (изначально узел назначения переменных) - это важный узел в рабочем процессе. Он отвечает за интеграцию выходных результатов разных ветвей, гарантируя, что независимо от того, какая ветвь выполнена, ее результат может быть ссылочно доступен через единую переменную. Это чрезвычайно полезно в сценариях с несколькими ветвями, так как он отображает переменные с той же функцией в разных ветвях на одну выходную переменную, избегая избыточных определений в нижестоящих узлах.',
      variableAssigner: 'Назначитель переменных',
      variableAssignerDescription:
        'Этот компонент выполняет операции над объектами Data, включая извлечение, фильтрацию и редактирование ключей и значений в Data.',
      variableDescription: 'Описание переменной',
      variableNameMessage:
        'Имя переменной может содержать только буквы и подчеркивания',
      watermarkText: 'Текст водяного знака',
      agentLog: {
        log: 'Журнал',
        agent: 'Агенты',
        idTitle: 'ID/Название',
        latestDate: 'Дата обновления',
        search: 'Поиск',
        reset: 'Сбросить',
        id: 'ID',
        title: 'Название',
        state: 'Статус',
        number: 'Номер',
        createDate: 'Дата создания',
        noData: 'Нет данных',
        loading: 'Загрузка...',
      },
      autoPlay: 'Автовоспроизведение аудио',
      enableChildrenDelimiters: 'Дочерние фрагменты используются для поиска',
      loopDescription:
        'Цикл — верхний предел итераций текущего компонента. При превышении лимита компонент не сможет выполнить задачу; пересмотрите логику агента.',
      exitLoop: 'Выход из цикла',
      exitLoopDescription:
        'Аналог «break». Узел без настроек. При достижении этого узла цикл завершается.',
      loopVariables: 'Переменные цикла',
      maximumLoopCount: 'Максимальное число итераций',
      loopTerminationCondition: 'Условие завершения цикла',
      tocDataSource: 'Источник данных',
      toc: 'Индекс страниц',
      webhook: {
        name: 'Webhook',
        methods: 'Методы',
        contentTypes: 'Типы контента',
        security: 'Безопасность',
        schema: 'Схема',
        response: 'Ответ',
        executionMode: 'Режим выполнения',
        executionModeTip:
          'Принятый ответ: система сразу возвращает подтверждение после валидации запроса, а рабочий процесс выполняется асинхронно в фоне. /Финальный ответ: система возвращает ответ только после полного выполнения процесса.',
        authMethods: 'Методы аутентификации',
        authType: 'Тип аутентификации',
        limit: 'Лимит частоты запросов',
        per: 'Период времени',
        maxBodySize: 'Максимальный размер тела запроса',
        ipWhitelist: 'Белый список IP',
        tokenHeader: 'Заголовок токена',
        tokenValue: 'Значение токена',
        username: 'Имя пользователя',
        password: 'Пароль',
        algorithm: 'Алгоритм',
        secret: 'Секрет',
        issuer: 'Издатель',
        audience: 'Аудитория',
        requiredClaims: 'Обязательные claims',
        header: 'Заголовок',
        status: 'Статус',
        headersTemplate: 'Шаблон заголовков',
        bodyTemplate: 'Шаблон тела',
        basic: 'Basic',
        bearer: 'Bearer',
        apiKey: 'API-ключ',
        queryParameters: 'Параметры запроса',
        headerParameters: 'Параметры заголовка',
        requestBodyParameters: 'Параметры тела запроса',
        immediately: 'Принятый ответ',
        streaming: 'Финальный ответ',
        overview: 'Обзор',
        logs: 'Логи',
        agentStatus: 'Статус агента:',
      },
      saveToMemory: 'Сохранить в память',
      retrievalFrom: 'Источник поиска',
    },
    llmTools: {
      bad_calculator: {
        name: 'Калькулятор',
        description:
          'Инструмент для вычисления суммы двух чисел (дает неверный ответ)',
        params: {
          a: 'Первое число',
          b: 'Второе число',
        },
      },
    },
    modal: {
      okText: 'Подтвердить',
      cancelText: 'Отмена',
    },
    dataflowParser: {
      result: 'Результат',
      parseSummary: 'Итог парсинга',
      parseSummaryTip: 'Парсер: deepdoc',
      parserMethod: 'Метод парсера',
      outputFormat: 'Формат вывода',
      rerunFromCurrentStep: 'Перезапустить с текущего шага',
      rerunFromCurrentStepTip:
        'Обнаружены изменения. Нажмите, чтобы перезапустить.',
      confirmRerun: 'Подтвердить перезапуск',
      confirmRerunModalContent:
        '\n' +
        '      <p class="text-sm text-text-disabled font-medium mb-2">\n' +
        '        Вы перезапустите процесс, начиная с шага <span class="text-text-secondary">{{step}}</span>.\n' +
        '      </p>\n' +
        '      <p class="text-sm mb-3 text-text-disabled">Будет выполнено:</p><br />\n' +
        '      <ul class="list-disc list-inside space-y-1 text-sm text-text-secondary">\n' +
        '        <li>• Перезапись результатов с текущего шага и дальше</li>\n' +
        '        <li>• Создание новой записи лога</li>\n' +
        '        <li>• Предыдущие шаги останутся без изменений</li>\n' +
        '      </ul>',
      changeStepModalTitle: 'Предупреждение при смене шага',
      changeStepModalContent:
        '\n' +
        '      <p>Вы редактируете результаты этого этапа.</p>\n' +
        '      <p>Если перейдете к следующему этапу, изменения будут потеряны. </p>\n' +
        '      <p>Чтобы сохранить, нажмите «Перезапустить», чтобы перезапустить текущий этап.</p> ',
      changeStepModalConfirmText: 'Все равно переключить',
      changeStepModalCancelText: 'Отмена',
      unlinkPipelineModalTitle: 'Отвязать конвейер загрузки',
      unlinkPipelineModalConfirmText: 'Отвязать',
      unlinkPipelineModalContent:
        '\n' +
        '      <p>После отвязки этот набор данных больше не будет связан с текущим конвейером загрузки.</p>\n' +
        '      <p>Файлы, которые уже обрабатываются, продолжат обработку до завершения.</p>\n' +
        '      <p>Файлы, которые еще не обрабатывались, обработаны не будут.</p> <br/>\n' +
        '      <p>Вы уверены?</p> ',
      unlinkSourceModalTitle: 'Отвязать источник данных',
      unlinkSourceModalContent:
        '\n      <p>Вы уверены, что хотите отвязать этот источник данных？</p>',
      unlinkSourceModalConfirmText: 'Отвязать',
    },
    datasetOverview: {
      downloadTip: 'Файлы скачиваются из источников.',
      processingTip: 'Файлы обрабатываются конвейером загрузки.',
      totalFiles: 'Всего файлов',
      downloading: 'Скачиваются',
      processing: 'Обрабатываются',
      downloadSuccessTip: 'Всего успешных загрузок',
      downloadFailedTip: 'Всего неудачных загрузок',
      processingSuccessTip: 'Всего успешно обработанных файлов',
      processingFailedTip: 'Всего ошибок обработки',
      noData: 'Логов пока нет',
    },
    mcp: {
      bulkManage: 'Массовое управление',
      cachedTools: 'кэшированные инструменты',
      customizeTheListOfMcpServers: 'Настроить список MCP серверов',
      exitBulkManage: 'Выйти из массового управления',
      mcpServer: 'MCP сервер',
      mcpServers: 'MCP серверы',
      selected: 'Выбрано',
      toolsAvailable: 'доступных инструментов',
      export: 'Экспорт',
      import: 'Импорт',
      url: 'URL',
      serverType: 'Тип сервера',
      addMCP: 'Добавить MCP',
      editMCP: 'Редактировать MCP',
    },
    search: {
      createSearch: 'Создать поиск',
      AISummary: 'Сводка ИИ',
      avatar: 'Аватар',
      cancelText: 'Отмена',
      chooseDataset: 'Сначала выберите набор данных',
      copySuccess: 'Копировано успешно',
      datasets: 'Базы знаний',
      description: 'Описание',
      descriptionValue: 'Вы — интеллектуальный ассистент.',
      embedApp: 'Встроить приложение',
      embedCode: 'Код встраивания',
      enableRelatedSearch: 'Включить связанный поиск',
      enableWebSearch: 'Включить веб-поиск',
      id: 'ID',
      locale: 'Локаль',
      name: 'Название',
      okText: 'Сохранить',
      profile: 'Скрыть профиль',
      relatedSearch: 'Связанный поиск',
      rerankModel: 'Модель реранкинга',
      searchApps: 'Приложения поиска',
      searchGreeting: 'Чем я могу вам помочь сегодня?',
      searchSettings: 'Настройки поиска',
      showQueryMindmap: 'Показать карту запроса',
      welcomeBack: 'С возвращением',
      hiThere: 'Здравствуйте!',
    },
    showcaseNew: {
      title: 'Витрина ИИ-помощников',
      searchPlaceholder: 'Поиск',
      error: 'Ошибка загрузки сервисов',
      notFound: 'Сервисы не найдены',
      comingSoonBadge: 'Скоро',
      bannerComingSoon: 'Скоро',
      categories: {
        all: 'Все',
        assistant: 'Помощники',
        documents: 'Документы',
        media: 'Медиа',
        analytics: 'Аналитика',
        business: 'Бизнес',
        text: 'Текст',
        support: 'Поддержка',
        education: 'Обучение',
        automation: 'Автоматизация',
        integration: 'Интеграции',
        other: 'Другое',
      },
      modal: {
        subtitle: 'Этот помощник скоро будет доступен на платформе',
        inProgress: 'Мы работаем над этим',
        whatToExpect: 'Что вас ждет',
        fallbackDescription:
          'Интеллектуальный помощник с передовыми возможностями ИИ для решения ваших задач',
        actionClose: 'Понятно',
      },
    },
    showcaseAdmin: {
      sourceLabel: 'Источник',
      title: 'Управление витриной',
      save: 'Сохранить',
      create: 'Создать',
      add: 'Добавить',
      delete: 'Удалить',
      cancel: 'Отмена',
      loading: 'Загрузка...',
      allStatuses: 'Все статусы',
      allCollections: 'Все витрины',
      noTitle: '(без заголовка)',
      unknown: 'Неизвестный',
      nothingFound: 'Ничего не найдено',
      noTenantsAvailable: 'Нет доступных тенантов',
      tenantMembersCount: '{{count}} чел.',
      confirmDeleteShowcaseTitle: 'Удалить карточку?',
      confirmDeleteShowcaseContent:
        'Вы уверены, что хотите удалить "{{title}}"?',
      confirmDeleteBannerTitle: 'Удалить баннер?',
      confirmDeleteBannerContent: 'Вы уверены, что хотите удалить этот баннер?',
      buttons: {
        addCard: 'Добавить карточку',
        addBanner: 'Добавить баннер',
        addCollection: 'Добавить витрину',
        openCards: 'Показать её карточки',
      },
      tabs: {
        collections: 'Витрины',
        cards: 'Карточки',
        banner: 'Баннер',
        card: 'Карточка',
        visibility: 'Видимость',
        targets: 'Привязки',
      },
      columns: {
        title: 'Название',
        category: 'Категория',
        status: 'Статус',
        visibility: 'Видимость',
        bindings: 'Привязки',
        order: 'Порядок',
        actions: 'Действия',
        bannerTitle: 'Заголовок',
        collection: 'Витрина',
        collectionName: 'Название',
        audience: 'Аудитория',
        priority: 'Приоритет',
        content: 'Содержимое',
      },
      actions: {
        configure: 'Настроить',
        edit: 'Редактировать',
        delete: 'Удалить',
      },
      drawer: {
        settingsFor: 'Настройка: {{title}}',
      },
      fields: {
        icon: 'Иконка',
        title: 'Название',
        description: 'Описание',
        category: 'Категория',
        status: 'Статус',
        order: 'Порядок',
        badgeText: 'Текст лейбла',
        badgeColor: 'Цвет лейбла',
        bannerTitle: 'Заголовок',
        buttonText: 'Текст кнопки',
        buttonUrl: 'URL кнопки',
        collection: 'Витрина',
        collectionName: 'Название',
        pageTitle: 'Заголовок страницы',
        priority: 'Приоритет',
      },
      placeholders: {
        serviceTitle: 'Название сервиса',
        serviceDescription: 'Описание сервиса',
        badgeText: 'Beta',
        learnMore: 'Узнать больше',
        collectionName: 'Например, Руководство',
        pageTitle: 'Пусто — стандартный заголовок',
        searchUsers: 'Поиск пользователей',
        searchTenants: 'Поиск команд',
      },
      dialogs: {
        newCard: 'Новая карточка',
        editBanner: 'Редактировать баннер',
        newBanner: 'Новый баннер',
      },
      collections: {
        hint: 'Пользователь видит ровно одну витрину: подходящую ему по аудитории, иначе общую. Карточка из общей витрины на кураторскую не попадёт.',
        defaultName: 'Общая',
        defaultBadge: 'По умолчанию',
        defaultExplainer:
          'Это страница, на которую попадает пользователь, если ему не подошла ни одна другая витрина. Поэтому у неё нет аудитории и её нельзя удалить.',
        fieldHint: 'На какой главной странице это показывать.',
        pageTitleHint: 'Пусто — остаётся стандартный заголовок.',
        priorityHint:
          'Если пользователю подходит несколько витрин, побеждает та, у которой приоритет выше. Персональной витрине ставьте число больше, чем командной.',
        audienceTitle: 'Аудитория',
        audienceHint:
          'Отдельные пользователи и целые команды — команда адресует витрину всем участникам.',
        audienceUsers: 'Пользователи',
        audienceTenants: 'Команды',
        audienceFallback: 'Все, кому не подошла другая витрина',
        audienceEmpty: 'Нет аудитории — её никто не видит',
        audienceEmptyWarning:
          'Без аудитории эта витрина не показывается никому.',
        tenantsCount: 'команд: {{count}}',
        usersCount: 'пользователей: {{count}}',
        contentCounts: 'карточек: {{cards}} · баннеров: {{banners}}',
        newTitle: 'Новая витрина',
        editTitle: 'Редактировать витрину',
        confirmDeleteTitle: 'Удалить витрину?',
        confirmDeleteContent:
          'Удалить «{{name}}»? Её карточки и баннеры перейдут в «{{defaultName}}» — ничего не потеряется.',
      },
      preview: {
        title: 'Заголовок',
        description: 'Описание',
      },
      badge: {
        title: 'Лейбл карточки',
        hint: 'Опциональный лейбл для карточек с привязкой. Оставьте пустым, чтобы скрыть его.',
        preview: 'Предпросмотр',
      },
      badgeColors: {
        blue: 'Синий',
        purple: 'Фиолетовый',
        green: 'Зеленый',
        amber: 'Янтарный',
        red: 'Красный',
        slate: 'Серый',
      },
      categories: {
        assistant: 'Помощники',
        documents: 'Документы',
        media: 'Медиа',
        analytics: 'Аналитика',
        business: 'Бизнес',
        text: 'Текст',
        support: 'Поддержка',
        education: 'Обучение',
        automation: 'Автоматизация',
        integration: 'Интеграции',
        other: 'Другое',
      },
      statuses: {
        draft: 'Черновик',
        active: 'Активный',
        archived: 'Архив',
      },
      visibility: {
        visibleToAllTenants: 'Видна всем тенантам',
        visibleToTenantCount: 'Видна {{count}} тенантам',
        all: 'Всем',
        visibleToAll: 'Видна всем',
        visibleToSelected: 'Видна выбранным тенантам',
        cardVisibleToAllHint: 'Карточка будет отображаться для всех тенантов',
        selectedCount: 'Выбрано: {{count}}',
        selectedCountLabel: 'Выбрано:',
        active: 'Активно',
        selectSpecificTenants: 'Или выберите конкретные тенанты:',
        searchByNameOrId: 'Поиск по названию или ID',
        rule: 'Правило',
        mode: {
          whitelist: 'Только выбранным',
          blacklist: 'Всем, кроме выбранных',
        },
        visibleToAllExcept: 'Видна всем, кроме выбранных тенантов',
        visibleToAllExceptCount: 'Видна всем, кроме {{count}} тенантов',
        allExcept: 'Все кроме {{count}}',
        excludedCount: 'Скрыта для: {{count}}',
      },
      targets: {
        editBinding: 'Редактировать привязку',
        newBinding: 'Новая привязка',
        existingBindings: 'Существующие привязки:',
        type: 'Тип',
        selectType: 'Выберите тип',
        comingSoonNoBinding: 'Coming Soon (без привязки)',
        chat: 'Чат',
        agent: 'Агент',
        externalUrl: 'Внешняя ссылка',
        url: 'Ссылка',
        urlPlaceholder: 'https://example.com',
        searchByNameOrOwner: 'Поиск по названию или владельцу...',
      },
    },
    agentTemplates: {
      general_chat_bot: {
        title: 'Универсальный чат-бот',
        description:
          'Чат-бот общего назначения, применимый в области здравоохранения, финансов, эмоционального общения, прогноза погоды и предоставления информации.',
      },
      customer_service: {
        title: 'Служба поддержки',
        description:
          'Чат-бот службы поддержки, который объясняет характеристики продукта, отвечает на запросы клиентов и снимает негативные эмоции.',
      },
      hr_callout: {
        title: 'Помощник по рекрутменту (китайский)',
        description:
          'Помощник по презентации кандидата, представляющий вакансию, отвечающий на вопросы и запрашивающий контактные данные кандидата. Начните с привязки базы знаний, содержащей описание работы, в модуле «Retrieval»!',
      },
      interpreter: {
        title: 'Переводчик',
        description:
          'Агент перевода, основанный на рефлексивном рабочем процессе, вдохновленный проектом Эндрю Нга: https://github.com/andrewyng/translation-agent\n' +
          '\n' +
          '1. Запросите LLM перевести текст на целевой язык.\n' +
          '2. Попросите LLM дать рекомендации по улучшению перевода.\n' +
          '3. Используйте эти рекомендации для улучшения перевода.',
      },
      db_assistant: {
        title: 'DB Assistant',
        description:
          'Продвинутый агент, преобразующий запросы пользователей в SQL-запросы, выполняющий их и оценивающий результаты. Необходимо подготовить три базы знаний: 1: DDL вашей базы данных; 2: Примеры запросов пользователей и их преобразование в SQL; 3: Описание вашей базы данных, включая таблицы и записи. Также требуется настроить соответствующую базу данных.',
      },
      text2sql: {
        title: 'Text To SQL',
        description:
          'Агент, преобразующий запросы пользователей в SQL-запросы. Необходимо подготовить три базы знаний: 1: DDL вашей базы данных; 2: Примеры запросов и их преобразование в SQL; 3: Подробное описание базы данных, включая таблицы и записи.',
      },
      medical_consultation: {
        title: 'Медицинская консультация',
        description:
          'Консультант, предлагающий медицинские рекомендации, используя внутреннюю QA-базу и результаты поиска PubMed. Ответы носят справочный характер и могут быть недостоверными. Набор данных доступен по адресу https://huggingface.co/datasets/InfiniFlow/medical_QA/tree/main',
      },
      investment_advisor: {
        title: 'Интеллектуальный инвестиционный советник',
        description:
          'Интеллектуальный инвестиционный советник, отвечающий на финансовые вопросы, используя актуальные данные финансовых рынков.',
      },
      seo_blog: {
        title: 'Генератор SEO-блогов',
        description:
          'Генератор блогов, создающий SEO-оптимизированный контент на основе выбранного вами заголовка или ключевых слов.',
      },
      research_report: {
        title: 'Генератор исследовательских отчётов',
        description:
          'Генератор отчётов, создающий исследовательский отчёт по заданному названию на выбранном языке. Генерирует запросы из входного заголовка, затем создает подпункты и разделы, формируя полный отчёт.',
      },
      websearch_assistant: {
        title: 'Помощник веб-поиска',
        description:
          "Шаблон чат-помощника, объединяющий информацию из базы знаний и результатов веб-поиска для ответа на запросы. Сначала настройте базу знаний в модуле 'Retrieval'!",
      },
    },
    footer: {
      profile: 'Все права защищены @ React',
    },
    layout: {
      file: 'файл',
      knowledge: 'знания',
      chat: 'чат',
    },
    telegramConnector: {
      tokenGenerationError: 'Не удалось сгенерировать токен',
      channelConnectedSuccess: 'Канал успешно подключен!',
      tokenExpiredError: 'Токен истек. Попробуйте еще раз.',
      step1Title: 'Привязка к базе знаний',
      step2Title: 'Привязка к каналу',
      step3Title: 'Проверка прав',
      step1Description:
        'Нажмите на кнопку, чтобы связать подключение с базой знаний.',
      step2Description: 'Перешлите сообщение из вашего канала',
      step3DescriptionPrefix: 'Добавьте',
      step3DescriptionSuffix: 'как администратора в канал.',
      generating: 'Генерация...',
      clickToConnect: 'Кликните здесь для подключения',
      tryAgain: 'Попробовать еще раз',
      cancel: 'Отмена',
      continue: 'Продолжить',
      waitingForForward: '⏳ Ожидание пересылки сообщения...',
      waitingForAdmin: '⏳ Ожидание предоставления прав администратора...',
      channelConnectedAndSyncing: '✅ Канал подключен и синхронизируется',
    },
    telegramHooks: {
      channelConnectedSuccess: 'Канал Telegram успешно подключен!',
      channelSyncStartedSuccess:
        'Синхронизация канала Telegram успешно запущена',
      failedToConnect: 'Не удалось подключить канал Telegram',
      failedToSync: 'Не удалось синхронизировать канал Telegram',
      syncFailed: 'Синхронизация не удалась: {{error}}',
    },
    telegramModal: {
      title: 'Telegram источник',
      sourceType: 'Тип источника',
      sourceTypeTooltip: 'Выберите тип Telegram источника для подключения',
      channel: 'Канал',
      group: 'Группа',
      comingSoon: 'Скоро будет доступно',
      groupConfigurationComingSoon:
        'Настройка групп Telegram скоро будет доступна. Пока что используйте каналы.',
      connectionType: 'Тип подключения',
      connectionTypeTooltip: 'Выберите, как получать доступ к каналу Telegram',
      link: 'Ссылка',
      linkTooltip:
        'Имя пользователя канала или ссылка (можете вставить прямо из Telegram)',
      linkPlaceholder: '@channelname',
      webScraping: 'Веб-скрапинг',
      webScrapingDescription: 'Работает с любым публичным каналом.',
      botApi: 'Bot API',
      botApiDescription:
        'Бот должен быть администратором. Обновления с минимальной задержкой.',
      notConfigured: '(Не настроен)',
      checkInterval: 'Интервал обновлений (минуты)',
      checkIntervalTooltip: 'Как часто проверять новые сообщения',
      checkIntervalMinMessage: 'Минимальный интервал проверки - 5 минут',
      preview: 'Предварительный просмотр',
      cancel: 'Отмена',
      connect: 'Подключить',
      pleaseSelectConnectionType: 'Пожалуйста, выберите тип подключения',
      pleaseEnterChannelLink: 'Пожалуйста, введите ссылку на канал',
      botNotConfigured: 'Бот не настроен',
      botNotConfiguredDescription:
        'Системный бот Telegram не настроен для этого метода.',
      adminConfigureBot:
        '💡 Администратор: Пожалуйста, настройте бота Telegram в conf/service_conf.yaml и перезапустите приложение.',
      channelPreview: 'Предварительный просмотр канала',
      channelPreviewFailed: 'Ошибка предварительного просмотра канала',
      clickPreviewButton:
        'Нажмите кнопку предварительного просмотра, чтобы увидеть информацию о канале',
      recentMessages: 'Недавние сообщения',
      members: 'участников',
      unknownMembers: 'Неизвестно участников',
      views: 'просмотров',
      channelNotFound:
        'Канал не найден. Пожалуйста, проверьте имя пользователя или ссылку на канал.',
      channelPrivate:
        'Этот канал приватный и не может быть предварительно просмотрен. Вы все еще можете попробовать подключиться с помощью Bot API, если у вас есть права администратора.',
      unableToAccessMessages:
        'Невозможно получить доступ к сообщениям канала. Канал может быть приватным, пустым или не существовать.',
      channelFoundNoMessages:
        'Канал найден, но нет доступных недавних сообщений.',
      connectionTimeout: 'Тайм-аут соединения. Пожалуйста, попробуйте позже.',
      networkConnectionError:
        'Ошибка сетевого соединения. Пожалуйста, проверьте ваше интернет-соединение.',
      invalidChannelFormat:
        'Неверный формат имени пользователя канала. Пожалуйста, используйте формат @channelname или t.me/channelname.',
      commonSolutions: '💡 Общие решения:',
      checkChannelUsername:
        '• Проверьте, правильно ли указано имя пользователя канала',
      tryBotApi:
        '• Попробуйте использовать метод Bot API для приватных каналов',
      ensurePublicChannel:
        '• Убедитесь, что канал публичный при использовании веб-скрапинга',
      checkNetworkConnection: '• Проверьте ваше сетевое соединение',
      pleaseEnterChannelFirst: 'Пожалуйста, введите ссылку на канал',
    },
    telegramStatus: {
      syncing: 'Синхронизация...',
      synchronized: 'Синхронизировано',
      needsSync: 'Требует синхронизации',
      syncPaused: 'Синхронизация приостановлена',
      notSynced: 'Не синхронизировано',
      unknown: 'Неизвестно',
      never: 'Никогда',
      pendingInitialSync: 'Ожидание первичной синхронизации',
      overdue: 'Просрочено',
      channel: 'Канал',
      lastSync: 'Последняя синхронизация',
      nextSync: 'Следующая синхронизация',
      interval: 'Интервал',
      autoSync: 'Авто-синхронизация',
      enabled: 'Включено',
      disabled: 'Отключено',
      sync: 'Синхронизация',
      telegramSyncStatus: 'Статус синхронизации Telegram',
      paused: 'Приостановлено',
      outdated: 'Устарело',
      unknownChannel: 'Неизвестный канал',
    },
    assessment: {
      panelTitle: 'Оценка качества',
      review: 'Ревью',
      reviewedOk: 'Проверено: OK',
      reviewedNotOk: 'Проверено: FAIL',
      counterLabel: 'Оценено сегодня:',
      counterValue: '{{reviewed}}',
      selectAnswer: 'Задайте вопрос ассистенту, чтобы оценить его ответ.',
      ok: 'OK',
      notOk: 'FAIL',
      commentLabel: 'Комментарий',
      commentHint:
        'Любой комментарий, который поможет понять, почему ответ был оценен так или иначе.',
      expectedAnswerLabel: 'Ожидаемый ответ',
      expectedAnswerHint:
        'Заполните, чтобы показать, как должен был выглядеть правильный ответ.',
      referenceDocuments: 'Документы',
      referenceDocumentsHint:
        'Прикрепите документы из баз знаний, в которых находится ответ на вопрос.',
      addDocuments: 'Добавить',
      screenshots: 'Скриншоты',
      screenshotsHint:
        'Прикрепите скриншоты для дополнительных пояснений, если они необходимы.',
      screenshotsRefused:
        'Нельзя прикрепить (нужны PNG, JPEG, GIF или WebP без «:» в имени): {{names}}',
      addScreenshots: 'Добавить',
      uploadingScreenshots: 'Загрузка скриншотов...',
      documentSearchTitle: 'Найти документы-референсы',
      documentSearchPlaceholder: 'Поиск документов по названию или содержимому',
      documentSearchNoSnippet: 'Совпадение найдено по названию документа.',
      documentSearchRecentItem: 'Документ из связанных баз знаний.',
      selectedDocument: 'Выбрано',
      selectDocument: 'Выбрать',
      noDocumentResults: 'Документы не найдены.',
      submitReview: 'Отправить',
      submitOk: 'Ответ верный',
      submitNotOk: 'Ответ неверный',
      notOkSubmitHint:
        'Чтобы отметить ответ как неверный, заполните хотя бы комментарий или ожидаемый правильный ответ.',
      notEligibleTitle: 'Режим оценки недоступен',
      notEligibleDescription:
        'Для этого чата нет активной кампании оценки качества, доступной вашему пользователю.',
      unavailableTitle: 'Режим assessment недоступен',
      unavailableDescription:
        'Эта страница временно недоступна, потому что техническая проверка режима ревью еще не готова.',
      switchToReview: 'Режим оценки',
      switchToChat: 'Режим чата',
      questionsTitle: 'Ответьте на вопросы',
      questionsHint:
        'Перед отправкой оценки ответьте на все настроенные вопросы да/нет.',
      campaigns: {
        navTitle: 'Оценка качества',
        title: 'Оценка качества',
        subtitle:
          'Управляйте кампаниями оценки и открывайте результаты по каждой кампании.',
        create: 'Создать кампанию',
        save: 'Сохранить кампанию',
        createTitle: 'Создать кампанию оценки',
        editTitle: 'Редактировать кампанию оценки',
        openResults: 'Открыть результаты',
        searchPlaceholder: 'Поиск кампаний по названию',
        allStatuses: 'Все статусы',
        statusDraft: 'Черновик',
        statusActive: 'Активна',
        statusArchived: 'Архив',
        status: {
          draft: 'Черновик',
          active: 'Активна',
          archived: 'Архив',
        },
        fields: {
          targetType: 'Тип цели',
          target: 'Цель',
          name: 'Название кампании',
          description: 'Описание',
          status: 'Статус',
          audience: 'Аудитория',
          questions: 'Вопросы да / нет',
          questionLabel: 'Текст вопроса',
          questionDescription: 'Заметка для ревьюера',
          users: 'Пользователи',
          tenants: 'Тенанты',
        },
        placeholders: {
          chat: 'Выберите чат',
          agent: 'Выберите агента',
          users: 'Выберите пользователей',
          tenants: 'Найти тенанты',
          question: 'Формулировка вопроса',
          questionDescription: 'Необязательное пояснение для ревьюера',
        },
        target: {
          chat: 'Чат',
          agent: 'Агент',
        },
        audienceHint: 'Выберите хотя бы одного пользователя или тенант.',
        addQuestion: 'Добавить вопрос',
        questionLabel: 'Вопрос {{index}}',
        confirmDelete: 'Удалить кампанию "{{name}}"?',
        columns: {
          name: 'Кампания',
          target: 'Цель',
          status: 'Статус',
          questions: 'Вопросы',
          audience: 'Аудитория',
          actions: 'Действия',
        },
      },
      admin: {
        title: 'Оценки Качества',
        subtitle: 'Просмотр и экспорт оценок.',
        backToCampaigns: 'К списку кампаний',
        campaignQuestions: 'Вопросы оценки',
        campaignResults: 'Результаты кампании',
        campaignResultsSubtitle:
          'Просмотр и экспорт оценок для кампании «{{name}}».',
        searchPlaceholder: 'Поиск по ID, вопросу, ответу',
        assistantPlaceholder: 'Чат-ассистент',
        filters: 'Фильтры',
        dateRange: 'Дата отправки',
        clearDateRange: 'Сбросить дату',
        export: 'Экспорт',
        selectAll: 'Выбрать все на странице',
        selectOne: 'Выбрать запись',
        selectedDelete: 'Удалить выбранное ({{count}})',
        selectedDeleteAction: 'Удалить выбранные записи: {{count}}',
        selectedDeleteTitle: 'Удалить выбранные оценки',
        selectedDeleteDescription: 'Будут удалены выбранные записи: {{count}}.',
        selectedDeleteWarning:
          'Операция необратима. Будут удалены сами оценки, связи с документами и скриншотами, а файлы скриншотов тоже будут удалены из хранилища.',
        selectedDeleteConfirm: 'Удалить',
        selectedDeleteDisabledTitle:
          'Сначала выберите хотя бы одну запись галочкой',
        bulkDelete: 'Удалить',
        bulkDeleteAction: 'Удалить записи, попавшие под текущие фильтры',
        bulkDeleteTitle: 'Удалить оценки',
        bulkDeleteDescription:
          'Будут удалены все записи, попавшие под текущие фильтры: {{count}}.',
        bulkDeleteWarning:
          'Операция необратима. Из БД будут удалены сами оценки, связи с документами и скриншотами, а файлы скриншотов тоже будут удалены из хранилища.',
        bulkDeleteConfirm: 'Удалить',
        bulkDeleteDisabledTitle:
          'Для массового удаления сначала выберите хотя бы один фильтр',
        bulkDeleteEmptyTitle: 'По текущим фильтрам нет записей для удаления',
        statusGroup: 'Статус',
        attachmentsGroup: 'Вложения',
        documentsGroup: 'Документы',
        filterYes: 'Есть',
        filterNo: 'Нет',
        hasAttachments: 'Есть вложения',
        noAttachments: 'Нет вложений',
        hasDocuments: 'Есть документы',
        noDocuments: 'Нет документов',
        hasExpectedAnswer: 'Есть ожидаемый ответ',
        noExpectedAnswer: 'Нет ожидаемого ответа',
        openAttachment: 'Открыть вложение',
        attachment: 'Вложение',
        status: 'Статус',
        reviewer: 'Ревьюер',
        dialogId: 'ID ассистента',
        conversationId: 'ID сессии',
        messageId: 'ID сообщения',
        langfuseTrace: 'Трейс Langfuse',
        question: 'Вопрос',
        actualAnswer: 'Ответ ассистента',
        expectedAnswer: 'Ожидаемый ответ',
        comment: 'Комментарий',
        chunks: 'Чанки',
        documents: 'Документы',
        attachments: 'Вложения',
        submittedAt: 'Отправлено',
        viewFullAnswer: 'Открыть полностью',
        fullAnswerTitle: 'Полный ответ ассистента',
        chunksTitle: 'Полученные чанки ({{count}})',
        documentsTitle: 'Прикрепленные документы ({{count}})',
        chunkNumber: 'Чанк {{index}}',
        chunkPositions: 'Позиции',
        documentId: 'ID документа',
        openDocument: 'Открыть',
        openChunk: 'Открыть чанк',
        openLangfuseTrace: 'Открыть в Langfuse',
        documentIds: 'ID документов',
        chunkIds: 'ID чанков',
        attachmentUrls: 'URL вложений',
        columns: 'Колонки',
        columnsMap: {
          status: 'Статус',
          reviewer_email: 'Ревьюер',
          dialog_id: 'ID ассистента',
          conversation_id: 'ID сессии',
          message_id: 'ID сообщения',
          langfuse_trace_id: 'Трейс Langfuse',
          question_text: 'Вопрос',
          answer_text: 'Ответ ассистента',
          expected_answer: 'Ожидаемый ответ',
          comment: 'Комментарий',
          chunks_count: 'Чанки',
          documents_count: 'Документы',
          attachments_count: 'Вложения',
          submitted_time: 'Отправлено',
        },
      },
    },
    admin: {
      loginTitle: 'Административная консоль',
      title: 'Flexar Admin',
      goToSite: 'На главную',
      confirm: 'Подтвердить',
      close: 'Закрыть',
      yes: 'Да',
      no: 'Нет',
      delete: 'Удалить',
      cancel: 'Отмена',
      reset: 'Сбросить',
      import: 'Импорт',
      description: 'Описание',
      noDescription: 'Нет описания',
      resourceType: {
        dataset: 'Датасет',
        chat: 'Чат',
        agent: 'Агент',
        search: 'Поиск',
        file: 'Файл',
        team: 'Команда',
        memory: 'Память',
      },
      permissionType: {
        enable: 'Включить',
        read: 'Чтение',
        write: 'Запись',
        share: 'Поделиться',
      },
      serviceStatus: 'Статус сервиса',
      analytics: 'Аналитика',
      expenses: 'Расходы', // Flexar: PILOTFLEXARBR-44
      // Flexar: страница выдачи прав на аналитику и расходы (PILOTFLEXARBR-44)
      access: {
        title: 'Доступы',
        subtitle:
          'Кому выдано право видеть аналитику и расходы. Права суперпользователя и владельца тенанта выводятся из данных — их здесь нет.',
        people: 'Люди',
        search: 'Поиск по email или имени',
        person: 'Человек',
        right: 'Право',
        grantedBy: 'Выдал',
        when: 'Когда',
        log: 'Выданные права',
        superuser: 'суперпользователь',
        readonly: 'без своего тенанта',
        granted: 'Право выдано',
        revoked: 'Право снято',
        failed: 'Не удалось изменить право',
        capability: {
          analyticsSelf: 'Аналитика своих запросов',
          analyticsTeam: 'Аналитика команды',
          costSelf: 'Расходы своих запросов',
          team: 'Расходы команды',
          all: 'Расходы всей инсталляции',
          employees: 'Разрез по сотрудникам',
        },
      },
      userManagement: 'Управление пользователями',
      assessmentResults: 'Оценки Качества',
      registrationWhitelist: 'Белый список регистрации',
      roles: 'Роли',
      monitoring: 'Мониторинг',
      back: 'Назад',
      active: 'Активный',
      inactive: 'Неактивный',
      enable: 'Включить',
      disable: 'Выключить',
      all: 'Все',
      actions: 'Действия',
      newUser: 'Новый пользователь',
      email: 'Email',
      name: 'Имя',
      status: 'Статус',
      id: 'ID',
      serviceType: 'Тип сервиса',
      host: 'Хост',
      port: 'Порт',
      role: 'Роль',
      user: 'Пользователь',
      superuser: 'Суперпользователь',
      createTime: 'Время создания',
      lastLoginTime: 'Время последнего входа',
      lastUpdateTime: 'Время последнего обновления',
      isAnonymous: 'Анонимный',
      isSuperuser: 'Суперпользователь',
      deleteUser: 'Удалить пользователя',
      deleteUserConfirmation:
        'Вы уверены, что хотите удалить этого пользователя?',
      createNewUser: 'Создать нового пользователя',
      nickname: 'Имя пользователя',
      nicknamePlaceholder: 'Имя пользователя',
      username: 'Username',
      usernamePlaceholder: 'Username',
      changePassword: 'Изменить пароль',
      newPassword: 'Новый пароль',
      confirmNewPassword: 'Подтвердите новый пароль',
      password: 'Пароль',
      confirmPassword: 'Подтвердите пароль',
      generatePassword: 'Сгенерировать',
      passwordGenerated: 'Пароль сгенерирован',
      passwordGeneratedAndCopied: 'Пароль сгенерирован и скопирован',
      invalidEmail:
        'Пожалуйста, введите действительный адрес электронной почты!',
      passwordRequired: 'Пожалуйста, введите ваш пароль!',
      passwordMinLength: 'Пароль должен быть длиннее 8 символов.',
      confirmPasswordRequired: 'Пожалуйста, подтвердите ваш пароль!',
      confirmPasswordDoNotMatch: 'Введенные вами пароли не совпадают!',
      read: 'Чтение',
      write: 'Запись',
      share: 'Поделиться',
      create: 'Создать',
      extraInfo: 'Дополнительная информация',
      serviceDetail: 'Детали сервиса {{name}}',
      taskExecutorDetail: 'Детали исполнителя задачи',
      whitelistManagement: 'Управление белым списком',
      exportAsExcel: 'Экспорт в Excel',
      importFromExcel: 'Импорт из Excel',
      createEmail: 'Создать email',
      deleteEmail: 'Удалить email',
      editEmail: 'Редактировать email',
      deleteWhitelistEmailConfirmation:
        'Вы уверены, что хотите удалить этот email из белого списка? Это действие нельзя отменить.',
      importWhitelist: 'Импорт белого списка (Excel)',
      importSelectExcelFile: 'Excel файл (.xlsx)',
      importOverwriteExistingEmails: 'Перезаписать существующие emails',
      importInvalidExcelFile: 'Пожалуйста, выберите действительный Excel файл',
      importFileRequired: 'Пожалуйста, выберите файл для импорта',
      importFileTips:
        'Файл должен содержать один заголовочный столбец с именем <code>email</code>.',
      chunkNum: 'Чанки',
      docNum: 'Документы',
      tokenNum: 'Использовано токенов',
      language: 'Язык',
      createDate: 'Дата создания',
      updateDate: 'Дата обновления',
      permission: 'Права доступа',
      agentTitle: 'Название агента',
      canvasCategory: 'Категория канваса',
      newRole: 'Новая роль',
      addNewRole: 'Добавить новую роль',
      roleName: 'Название роли',
      roleNameRequired: 'Название роли обязательно',
      resources: 'Ресурсы',
      editRoleDescription: 'Редактировать описание роли',
      deleteRole: 'Удалить роль',
      deleteRoleConfirmation:
        'Вы уверены, что хотите удалить эту роль? Это действие нельзя отменить.',
      alive: 'Активен',
      timeout: 'Таймаут',
      fail: 'Неудача',
      sandboxSettings: 'Настройки песочницы',
      userType: 'Тип пользователя',
      normalUser: 'Обычный',
      bulkCreate: 'Массовое создание',
      bulkCreateTitle: 'Массовое создание пользователей',
      bulkCreateDescription:
        'Загрузите Excel-файл с двумя столбцами: ФИО и Email. Пароли будут сгенерированы автоматически. Результат с паролями скачается после создания.',
      bulkCreateFile: 'Excel-файл (.xlsx)',
      bulkCreateSelectFile: 'Выбрать файл',
      bulkCreateNoFile: 'Файл не выбран',
      bulkCreateTenant: 'Назначить в тенант',
      bulkCreateTenantPlaceholder: 'Выберите тенант (необязательно)',
      bulkCreateTenantLoading: 'Загрузка списка тенантов…',
      bulkCreateTenantEmpty: 'Нет доступных тенантов',
      bulkCreateTenantErrorShort: 'Не удалось загрузить тенанты',
      bulkCreateTenantError: 'Ошибка загрузки тенантов: {{error}}.',
      bulkCreateTenantRetry: 'Повторить',
      bulkCreateReadOnly: 'Только чтение (без личного пространства)',
      bulkCreateReadOnlyHint:
        'Пользователи с доступом только на чтение не будут иметь личного тенанта и не смогут создавать помощников, базы знаний и агентов.',
      bulkCreateSubmit: 'Создать пользователей',
      bulkCreateAllOk: 'Создано пользователей: {{count}}. Отчёт скачан.',
      bulkCreateAllFailed:
        'Не создано ни одного из {{count}}. Подробности в скачанном отчёте.',
      bulkCreatePartial:
        'Создано: {{created}}, ошибок: {{errors}}. Подробности в скачанном отчёте.',
      bulkCreateFileChanged:
        'Файл был изменён после выбора. Выберите файл заново и попробуйте снова.',
      // Flexar: регенерация паролей — восстановление, если оригинальный
      // ответ bulk-create пропал.
      bulkModeLabel: 'Действие',
      bulkModeCreate: 'Создать новых пользователей',
      bulkModeRegenerate: 'Перевыдать пароли существующим (восстановление)',
      bulkRegenDescription:
        'Загрузите тот же Excel-файл, что использовали при создании. Для каждой строки сгенерируется новый пароль; отчёт с новыми паролями скачается после обработки.',
      bulkRegenSubmit: 'Перевыдать пароли',
      bulkRegenAllOk: 'Перевыдано паролей: {{count}}. Отчёт скачан.',
      bulkRegenAllFailed:
        'Ни один пароль не перевыдан ({{count}} ошибок). Подробности в скачанном отчёте.',
      bulkRegenPartial:
        'Перевыдано: {{created}}, ошибок: {{errors}}. Подробности в скачанном отчёте.',
      // Flexar: read-only user type
      readonlyUser: 'Только чтение',
      readOnlyTooltipTitle: 'Что значит «только чтение»?',
      readOnlyTooltip:
        'Пользователь будет работать только с тем, чем с ним поделятся: помощниками, базами знаний и агентами в общих пространствах. Создавать своё содержимое он не сможет.',
      selectAll: 'Выбрать всех',
      selectRow: 'Выбрать пользователя',
      selectedCount: 'Выбрано: {{count}}',
      clearSelection: 'Снять выбор',
      bulkMakeReadOnly: 'Сделать только чтение',
      bulkRestoreWorkspace: 'Вернуть личное пространство',
      bulkReadOnlyAllOk: 'Готово: изменено {{count}}.',
      bulkReadOnlyPartial:
        'Изменено: {{ok}}. Не удалось: {{failed}} — у этих пользователей в личном пространстве есть данные.',
    },
    language: {
      russian: 'Русский',
      english: 'Английский',
      chinese: 'Китайский',
      spanish: 'Испанский',
      french: 'Французский',
      german: 'Немецкий',
      japanese: 'Японский',
      korean: 'Корейский',
      vietnamese: 'Вьетнамский',
    },
    pagination: {
      total: 'Всего {{total}}',
      page: '{{page}} / Стр.',
    },
    memories: {
      llmTooltip:
        'Анализирует содержание диалога, извлекает ключевую информацию и формирует структурированные сводки памяти.',
      embeddingModelTooltip:
        'Преобразует текст в числовые векторы для семантического поиска и извлечения из памяти.',
      embeddingModelError:
        'Тип памяти обязателен, тип «исходный» нельзя удалить.',
      memoryTypeTooltip:
        'Исходный: сырое содержание диалога между пользователем и агентом (по умолчанию обязателен).\n' +
        'Семантическая память: общие знания и факты о пользователе и мире.\n' +
        'Эпизодическая память: записи конкретных событий и опыта с отметками времени.\n' +
        'Процедурная память: освоенные навыки, привычки и автоматизированные процедуры.',
      raw: 'исходный',
      semantic: 'семантическая',
      episodic: 'эпизодическая',
      procedural: 'процедурная',
      editName: 'Редактировать название',
      memory: 'Память',
      createMemory: 'Создать память',
      name: 'Название',
      memoryNamePlaceholder: 'название памяти',
      memoryType: 'Тип памяти',
      embeddingModel: 'Модель эмбеддинга',
      selectModel: 'Выбрать модель',
      llm: 'LLM',
      delMemoryWarn:
        'После удаления все сообщения в этой памяти будут удалены и не смогут быть извлечены агентами.',
    },
    memory: {
      taskLogDialog: {
        title: 'Память',
        startTime: 'Время начала',
        status: 'Статус',
        details: 'Детали',
        success: 'Успешно',
        running: 'Выполняется',
        failed: 'Ошибка',
      },
      messages: {
        forget: 'Забыть',
        forgetMessageTip: 'Вы уверены, что хотите забыть это сообщение?',
        messageDescription:
          'Извлечение памяти настраивается через промпты и температуру в расширенных настройках.',
        copied: 'Скопировано!',
        contentEmbed: 'Встроенный контент',
        content: 'Контент',
        delMessageWarn:
          'После удаления это сообщение больше не будет извлекаться агентами.',
        forgetMessage: 'Забыть сообщение',
        sessionId: 'ID сессии',
        agent: 'Агент',
        type: 'Тип',
        validDate: 'Действует до',
        forgetAt: 'Забыть в',
        source: 'Источник',
        enable: 'Включено',
        action: 'Действие',
      },
      config: {
        memorySizeTooltip:
          'Учитывается размер текста каждого сообщения и его вектор эмбеддинга (≈ текст + измерения × 8 байт).\n' +
          'Пример: сообщение 1 КБ с эмбеддингом 1024 измерения занимает около 9 КБ. Лимит 5 МБ по умолчанию вмещает примерно 500 таких сообщений.',
        avatar: 'Аватар',
        description: 'Описание',
        memorySize: 'Размер памяти',
        advancedSettings: 'Расширенные настройки',
        permission: 'Права доступа',
        onlyMe: 'Только я',
        team: 'Команда',
        storageType: 'Тип хранилища',
        storageTypePlaceholder: 'Выберите тип хранилища',
        forgetPolicy: 'Политика забывания',
        temperature: 'Температура',
        systemPrompt: 'Системный промпт',
        systemPromptPlaceholder: 'Введите системный промпт',
        userPrompt: 'Промпт пользователя',
        userPromptPlaceholder: 'Введите промпт пользователя',
      },
      sideBar: {
        messages: 'Сообщения',
        configuration: 'Конфигурация',
      },
    },
    deleteModal: {
      delAgent: 'Удалить агента',
      delDataset: 'Удалить базу знаний',
      delSearch: 'Удалить поиск',
      delFile: 'Удалить файл',
      delFiles: 'Удалить файлы',
      delFilesContent: 'Выбрано файлов: {{count}}',
      delChat: 'Удалить чат',
      delMember: 'Удалить участника',
      delMemory: 'Удалить память',
    },
    empty: {
      noMCP: 'Нет доступных MCP-серверов',
      agentTitle: 'Пока не создано ни одного агента',
      notFoundAgent: 'Агент не найден',
      datasetTitle: 'Пока не создано ни одной базы знаний',
      notFoundDataset: 'База знаний не найдена',
      chatTitle: 'Пока не создано ни одного чата',
      notFoundChat: 'Чат не найден',
      searchTitle: 'Пока не создано ни одного поиска',
      notFoundSearch: 'Поиск не найден',
      memoryTitle: 'Пока не создано ни одной памяти',
      notFoundMemory: 'Память не найдена',
      addNow: 'Добавить сейчас',
    },
    explore: {
      title: 'Чат',
      welcome: 'Добро пожаловать в',
      canvasList: 'Список канвасов',
      sessions: 'Сессии',
      newSession: 'Новая сессия',
      newSessionLabel: 'Начать новый диалог',
      deleteSession: 'Удалить сессию',
      searchCanvas: 'Поиск канваса...',
      searchSessions: 'Поиск сессий...',
      noCanvasSelected: 'Выберите канвас',
      noSessionSelected: 'Выберите сессию или создайте новую',
      noSessionsFound: 'Сессии не найдены',
      createFirstSession: 'Создайте первую сессию',
      noCanvasFound: 'Канвасы не найдены',
      deleteSelectedConfirm: 'Вы уверены, что хотите удалить {{count}} сессий?',
      batchDeleteSessions: 'Удалить сессии',
    },
    presentation: {
      planTitle: 'План презентации',
      fileMeta: 'Слайдов: {{slides}} · {{size}}',
      fileDownload: 'Скачать',
      fileDownloadFailed: 'Не удалось скачать файл',
      backToChat: 'К диалогу',
      editorTitle: 'Редактор презентации',
      sources: 'Источники:',
      templateLabel: 'Шаблон:',
      templateLoading: 'загрузка…',
      templateNone: 'не выбран',
      changeTemplate: 'Сменить',
      generatePresentation: 'Сгенерировать презентацию',
      generating: 'Готовлю презентацию…',
      generateFailed: 'Не удалось запустить генерацию',
      templateRequired: 'Сначала выберите шаблон',
      modalTitle: 'Выбор шаблона презентации',
      modalConfirm: 'Применить',
      layoutsSuffix: 'макетов',
      tagStructured: 'Структурированный',
      tagFlexible: 'Гибкий',
      tagDefault: 'По умолчанию',
      deckSettings: 'Создание презентации',
      templateChipLabel: 'Шаблон',
      editSlide: 'Изменить слайд',
      removeSlide: 'Удалить слайд',
      addSlide: 'Добавить слайд',
      newSlideContent: 'Новый слайд',
      planSaveFailed: 'Не удалось сохранить план',
      planReviseFailed: 'Не удалось изменить план',
      planRevise: 'Изменить',
      planRevising: 'Меняю…',
      planRevisePlaceholder:
        'Опишите правку плана — например: сократи второй пункт',
      planApplied: 'Изменения применены',
      planUndo: 'Отмена',
      planTruncated: 'Часть слайдов сокращена до лимита',
      planDroppedCitations: 'Выдуманные ссылки на источники убраны',
      taskTitle: 'Собираю презентацию',
      taskHint: 'Вкладку можно закрыть — презентация останется здесь.',
      taskElapsed: '{{minutes}}:{{seconds}}',
      taskSlides: '{{created}} из {{total}} слайдов',
      settingsNotSaved:
        'Не удалось сохранить настройки презентации. Изменение действует для этой деки, но не переживёт перезагрузку страницы.',
      taskFailed: 'Не удалось собрать презентацию',
      taskFailedStalled:
        'Генератор перестал отвечать — чаще всего провайдер модели недоступен или отвечает слишком долго. Попробуйте ещё раз; если повторяется, выберите на ноде другую модель.',
      taskFailedTimeout:
        'Генерация не успела уложиться в отведённое время. Попробуйте меньше слайдов или другую модель на ноде.',
      taskFailedLost:
        'Сервис презентаций перезапустился и потерял эту генерацию. Попросите ещё раз — ничего не сохранилось.',
      taskFailedGeneric:
        'При сборке презентации что-то пошло не так. Попробуйте ещё раз.',
      // Названия этапов. Намеренно не английские строки самого Presenton: те —
      // произвольный текст, который он вправе переписать; сопоставление идёт по
      // машинному ключу.
      taskStageQueued: 'В очереди',
      taskStageStarting: 'Запускаю',
      taskStageOutline: 'Пишу план',
      taskStageLayout: 'Подбираю макеты',
      taskStageSlides: 'Наполняю слайды',
      taskStageAssets: 'Генерирую картинки',
      taskStageExport: 'Выгружаю файл',
      taskStageCompleted: 'Готово',
      taskStageUnknown: 'Работаю',
    },
  },
};
